import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import extAxios from '../../services/extAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const EMPTY_DATE = '1900-01-01';
const CURRENT_DATE = moment(new Date()).format('YYYY-MM-DD');
const state = {
    id: 0,
    /* Referencia al presupuesto inicial (para adicionales)*/
    presupuestoInternoInicialId: 0,
    fechaConfirmacion: EMPTY_DATE,
    fechaEntrega: CURRENT_DATE, // moment(new Date()).format('YYYY-MM-DD'),
    tipoPresupuestoId: 0,
    tipoPresupuesto: null,
    tipoPresupuestoNombre: null,
    presupuestoNumero: '',
    clienteId: 0,
    cliente: {},
    clienteNombre: null,
    condicionFiscalId: 0,
    accion: '',
    clienteContactoId: 0,
    clienteContacto: {},
    clienteContactoNombre: null,
    numeroOrdenCompra: '',
    fechaOrdenCompra: EMPTY_DATE,
    fechaOrdenCompraHabilitada: false,
    descripcionOrdenCompra: '',
    prioridadId: 0,
    prioridad: {},
    prioridadNombre: null,
    monedaId: 0,
    moneda: {},
    monedaNombre: null,
    monedaCotizacion: 0,
    pjeGastosFijos: 0,
    pjeInversionFutura: 0,
    pjeImpuestosInternos: 0,
    pjeIva: 0,
    feeAgencia: 0,
    aplicarEscalaFee: false,
    escalasFee: [],
    feeAgenciaPremios: 0,
    discriminarFee: false,
    ocultarLeyendaFee: false,
    discriminarFeePremios: false,
    reembolsos: false,
    // feeComisionable: false,
    pjeFinanciacion: 0,
    aplicarEscalaFinanciacion: false,
    pjeFinanciacionCliente: 0,
    discriminarPjeFinanciacion: false,
    feeSobreFinanciacion: false,
    escalasFinanciacion: [],
    discriminarCategoriaServicio: false,
    servicioPropioNoAplicaFee: false,
    prontoPagoFeeDiferenciado: false,
    pjeRecargoServicioPropio: 0,
    pjeMargenMinimoCotizacion: 0,
    pjeMargenMinimoCotizacionPropio: 0,
    pjeMargenMinimoCotizacionTerceros: 0,
    importeDescuentoRebate: 0,
    pjeDescuentoRebate: 0,
    importeDescuento: 0,
    pjeDescuento: 0,
    causaSocial: false,
    causaAmbiental: false,
    seleccionProvincias: false,
    propuestaAgencia: false,
    usuario: null,
    usuarioCoordinadorId: 0,
    usuarioCoordinador: null,
    usuarioCoordinadorNombre: null,

    autorizado: false,
    usuarioAutorizacion: '',
    fechaAutorizacion: EMPTY_DATE,

    ordenesTrabajo: [],
    ordenTrabajoSeleccionada: {},
    rowVersion: null,
    
    usuarios: [],
    facturacion: [],
    provincias: [],
    usuariosPropuesta: [],

    /* Parametros generales */
    pjeGastosFijosGlobal: 0,
    pjeInversionFuturaGlobal: 0,
    pjeImpuestosInternosGlobal: 0,
    pjeComisionInterna: 0,

    /* Ordenes de trabajo + renglon total de ordenes */
    ordenesTrabajoDatos: [],
    ordenesTrabajoTotales: [],

    /* Orden seleccionada para consultar y sus alternativas */
    ordenTrabajoAlternativas: {},
    alternativasDatos: [],
    ordenTrabajoAlternativaSeleccionada: {},

    /* Montos totales */
    montoCosto: 0,
    montoCotizacionBruta: 0,
    montoDescuentoOrdenes: 0,
    montoCotizacion: 0,
    montoSubtotalRebate: 0,
    montoFinanciacion: 0,
    montoFee: 0,
    montoFeePremios: 0,
    montoSubtotal: 0,

    montoTotal: 0,
    montoTotalPesos: 0,
    /* Neto e impuestos en $ */
    montoNeto: 0,
    montoImpuestos: 0,
    pjeRentabilidad: 0,
    pjeRentabilidadSinReembolsos: 0,

    confirmado: false,

    usuariosList: [],
    provinciasList: [],

    /* Monto total certificado */
    montoCertificado: 0,
    
    /* Comisiones */
    accesoComisiones: false,
    montoBaseComision: 0,
    vendedoresComisiones: [],

    /* Presupuesto Interno (Id, Nombre) */
    presupuestoSearch: {},
    ordenesListSearch: [],
    ordenesListSearchLogistica: false,

    presupuestoProduccionRpt: {},
    ordenesProduccion: [],

    imagenes: [],

    updated: false,
    errorMessage: ''
};

const mutations = {
    // updateField,

    updateField(state, field) {
        updateField(state, field);

        // console.log(field, state);
    },

    'INICIALIZAR_PRESUPUESTO' (state, params) {
        state.accesoComisiones = params.accesoComisiones;

        state.id = params.presupuestoId;
        state.presupuestoInternoInicialId = 0;
        state.fechaConfirmacion = EMPTY_DATE;
        state.fechaEntrega = CURRENT_DATE;
        state.tipoPresupuestoId = 0;
        state.tipoPresupuesto = null;
        state.tipoPresupuestoNombre = null;
        state.presupuestoNumero = '';
        state.clienteId= 0;
        state.cliente= null;
        state.clienteNombre= null;
        state.condicionFiscalId = 0;
        state.accion= '';
        state.clienteContactoId= 0;
        state.clienteContacto= null;
        state.clienteContactoNombre= null;
        state.numeroOrdenCompra = '';
        state.fechaOrdenCompra = EMPTY_DATE;
        state.fechaOrdenCompraHabilitada = false;
        state.descripcionOrdenCompra = '';
        state.prioridadId= 0;
        state.prioridad= null;
        state.prioridadNombre= null;
        state.monedaId= 0;
        state.moneda= null;
        state.monedaNombre= null;
        state.monedaCotizacion= 0;
        state.ordenesTrabajo= [];
        /* Parametros globales */
        state.pjeGastosFijos = 0;
        state.pjeInversionFutura = 0;
        state.pjeImpuestosInternos = 0;
        state.pjeIva = 0;
        state.feeAgencia = 0;
        state.aplicarEscalaFee = false;
        state.escalasFee = [];
        state.feeAgenciaPremios = 0;
        state.discriminarFee = false;
        state.ocultarLeyendaFee = false;
        state.discriminarFeePremios = false;
        state.reembolsos = false;
        // state.feeComisionable = false;
        state.pjeFinanciacion = 0;
        state.aplicarEscalaFinanciacion = false;
        state.pjeFinanciacionCliente = 0;
        state.discriminarPjeFinanciacion = false;
        state.feeSobreFinanciacion = false;
        state.escalasFinanciacion = [];
        state.discriminarCategoriaServicio = false;
        state.servicioPropioNoAplicaFee = false;
        state.prontoPagoFeeDiferenciado = false;
        state.pjeRecargoServicioPropio = 0;
        state.pjeMargenMinimoCotizacion = 0;
        state.pjeMargenMinimoCotizacionPropio = 0;
        state.pjeMargenMinimoCotizacionTerceros = 0;
        state.importeDescuentoRebate = 0;
        state.pjeDescuentoRebate = 0;
        state.importeDescuento = 0;
        state.pjeDescuento = 0;
        state.causaSocial = false;
        state.causaAmbiental = false;
        state.seleccionProvincias = false;
        state.propuestaAgencia = false;
        state.usuario = null;
        state.usuarioCoordinadorId = 0;
        state.usuarioCoordinador = null;
        state.usuarioCoordinadorNombre = null;
        state.autorizado = false;
        state.usuarioAutorizacion = '';
        state.fechaAutorizacion = EMPTY_DATE;
        state.rowVersion = null;

        state.usuarios = state.usuariosList.map(usuario => ({
            ...usuario,
            asignado: false,
            _rowVariant: ''
        }));
        
        state.facturacion = [];

        state.provincias = state.provinciasList.map(provincia => ({
            provinciaId: provincia.id,
            provincia: provincia.nombre,
            seleccionada: false
        }));

        state.usuariosPropuesta = state.usuariosList.map(usuario => ({
            ...usuario,
            asignado: false,
            _rowVariant: ''
        }));

        /* Ordenes de trabajo */
        state.ordenesTrabajoDatos = [];
        state.ordenesTrabajoTotales = [];

        state.confirmado = false;
        /* Montos totales */
        state.montoCosto = 0;
        state.montoCotizacion = 0;
        state.montoSubtotalRebate = 0;
        state.montoFinanciacion = 0;
        state.montoFee = 0;
        state.montoFeePremios = 0;
        state.montoSubtotal = 0;

        state.montoTotal = 0;
        state.montoTotalPesos = 0;
        state.montoNeto = 0;
        state.montoImpuestos = 0;

        state.montoCertificado = 0;
        
        state.montoBaseComision = 0;
        state.vendedoresComisiones = [];

        state.ordenTrabajoAlternativas = null;
        state.alternativasDatos = [];

        state.ordenTrabajoSeleccionada = null;
        state.ordenTrabajoAlternativaSeleccionada = null;

        /* Valores por defecto (moneda, prioridad) */
        setValoresIniciales(state);
    },
    'SET_PARAMETROS_PRESUPUESTO'(state, params) {
        state.pjeGastosFijos = params.pjeGastosFijos;
        state.pjeInversionFutura = params.pjeInversionFutura;
        state.pjeImpuestosInternos = params.pjeImpuestosInternos;
        state.pjeIva = params.pjeIva;

        /* Guardamos los parametros globales que se actualizan al recuperar la info del cliente */
        state.pjeGastosFijosGlobal = params.pjeGastosFijos;
        state.pjeInversionFuturaGlobal = params.pjeInversionFutura;
        state.pjeImpuestosInternosGlobal = params.pjeImpuestosInternos;

        state.pjeComisionInterna = params.pjeComisionInterna;

        state.usuario = params.usuario;
    },
    'SET_PJE_COMISION_INTERNA'(state, pjeComisionInterna) {
        state.pjeComisionInterna = pjeComisionInterna;
    },
    'SET_VISTA_ORDENES' (state, vista) {
        state.vistaOrdenesDatos =  vista;
    },
    'SET_PROVINCIAS' (state, provincias) {
        state.provinciasList =  provincias;
    },
    'SET_USUARIOS' (state, usuarios) {
        state.usuariosList = usuarios.map(usuario => ({
            usuarioId: usuario.id,
            usuario: usuario.nombreCompleto.trim(),
            usuarioRolId: usuario.usuarioRolId,
            usuarioRol: usuario.usuarioRol,
            inactivo: usuario.inactivo
        })).sort(function(a, b){
            let x = a.usuarioRol.toLowerCase().trim() + ' ' + a.usuario.toLowerCase().trim();
            let y = b.usuarioRol.toLowerCase().trim() + ' ' + b.usuario.toLowerCase().trim();
            if (x < y) { 
                return -1; 
            }
            if (x > y) {
                return 1;
            }
            return 0;
        });
    },
    'SET_PRESUPUESTO' (state, params) {
        state.presupuestoInternoInicialId = params.presupuesto.presupuestoInternoId;
        state.fechaConfirmacion = moment(params.presupuesto.fechaConfirmacion).format('YYYY-MM-DD');
        state.fechaEntrega = moment(params.presupuesto.fechaEntrega).format('YYYY-MM-DD');
        state.tipoPresupuestoId = params.presupuesto.tipoPresupuesto? params.presupuesto.tipoPresupuesto.id : 0;
        state.tipoPresupuesto = params.presupuesto.tipoPresupuesto;
        state.tipoPresupuestoNombre = params.presupuesto.tipoPresupuesto? params.presupuesto.tipoPresupuesto.nombre.trim() : null;
        state.presupuestoNumero = params.presupuesto.presupuestoNumero;
        state.clienteId= (params.presupuesto.cliente) ? parseInt(params.presupuesto.cliente.id) : 0;
        state.cliente= params.presupuesto.cliente;
        state.clienteNombre= params.presupuesto.cliente ? params.presupuesto.cliente.nombre.trim() : null;
        state.condicionFiscalId= params.presupuesto.condicionFiscalId;
        state.accion= params.presupuesto.accion.trim();
        state.clienteContactoId= (params.presupuesto.clienteContacto) ? parseInt(params.presupuesto.clienteContacto.id) : 0;
        state.clienteContacto= params.presupuesto.clienteContacto;
        state.clienteContactoNombre= params.presupuesto.clienteContacto ? params.presupuesto.clienteContacto.nombre.trim() : null;
        state.numeroOrdenCompra = params.presupuesto.numeroOrdenCompra.trim();
        state.fechaOrdenCompra = moment(params.presupuesto.fechaOrdenCompra).format('YYYY-MM-DD');
        if (moment(params.presupuesto.fechaOrdenCompra).format('YYYY-MM-DD') != EMPTY_DATE) {
            state.fechaOrdenCompraHabilitada = true;
        } else {
            state.fechaOrdenCompraHabilitada = false;   
        }
        state.descripcionOrdenCompra = params.presupuesto.descripcionOrdenCompra.trim();
        state.prioridadId= (params.presupuesto.prioridad) ? parseInt(params.presupuesto.prioridad.id) : 0;
        state.prioridad= params.presupuesto.prioridad;
        state.prioridadNombre= params.presupuesto.prioridad ? params.presupuesto.prioridad.nombre.trim() : null;
        state.monedaId= (params.presupuesto.moneda) ? parseInt(params.presupuesto.moneda.id) : 0;
        state.moneda= params.presupuesto.moneda;
        state.monedaNombre= params.presupuesto.moneda ? params.presupuesto.moneda.nombre.trim() : null;
        state.monedaCotizacion= parseFloat(params.presupuesto.monedaCotizacion);
        state.pjeGastosFijos = parseFloat(params.presupuesto.pjeGastosFijos);
        state.pjeInversionFutura = parseFloat(params.presupuesto.pjeInversionFutura);
        state.pjeImpuestosInternos = parseFloat(params.presupuesto.pjeImpuestosInternos);
        state.pjeIva = parseFloat(params.presupuesto.pjeIva);
        state.feeAgencia = parseFloat(params.presupuesto.feeAgencia);
        state.aplicarEscalaFee = (/true/i).test(params.presupuesto.aplicarEscalaFee);
        state.escalasFee = params.presupuesto.escalasFee;
        state.feeAgenciaPremios = parseFloat(params.presupuesto.feeAgenciaPremios);
        state.discriminarFee = (/true/i).test(params.presupuesto.discriminarFee);
        state.ocultarLeyendaFee = (/true/i).test(params.presupuesto.ocultarLeyendaFee);
        state.discriminarFeePremios = (/true/i).test(params.presupuesto.discriminarFeePremios);
        state.reembolsos = (/true/i).test(params.presupuesto.reembolsos);
        // state.feeComisionable = (/true/i).test(params.presupuesto.feeComisionable);
        state.pjeFinanciacion = parseFloat(params.presupuesto.pjeFinanciacion)
        state.aplicarEscalaFinanciacion = (/true/i).test(params.presupuesto.aplicarEscalaFinanciacion);
        state.pjeFinanciacionCliente = parseFloat(params.presupuesto.pjeFinanciacionCliente);
        state.discriminarPjeFinanciacion = (/true/i).test(params.presupuesto.discriminarPjeFinanciacion);
        state.feeSobreFinanciacion = (/true/i).test(params.presupuesto.feeSobreFinanciacion);
        state.escalasFinanciacion = params.presupuesto.escalasFinanciacion;
        state.discriminarCategoriaServicio = (/true/i).test(params.presupuesto.discriminarCategoriaServicio);
        state.servicioPropioNoAplicaFee = (/true/i).test(params.presupuesto.servicioPropioNoAplicaFee);
        state.prontoPagoFeeDiferenciado = (/true/i).test(params.presupuesto.prontoPagoFeeDiferenciado);
        state.pjeRecargoServicioPropio = parseFloat(params.presupuesto.pjeRecargoServicioPropio);
        state.pjeMargenMinimoCotizacion = parseFloat(params.presupuesto.pjeMargenMinimoCotizacion);
        state.pjeMargenMinimoCotizacionPropio = parseFloat(params.presupuesto.pjeMargenMinimoCotizacionPropio);
        state.pjeMargenMinimoCotizacionTerceros = parseFloat(params.presupuesto.pjeMargenMinimoCotizacionTerceros);
        state.importeDescuentoRebate = parseFloat(params.presupuesto.importeDescuentoRebate);
        state.pjeDescuentoRebate = 0;
        state.importeDescuento = parseFloat(params.presupuesto.importeDescuento);
        state.pjeDescuento = 0;
        state.causaSocial = (/true/i).test(params.presupuesto.causaSocial);
        state.causaAmbiental = (/true/i).test(params.presupuesto.causaAmbiental);
        state.seleccionProvincias = (/true/i).test(params.presupuesto.seleccionProvincias);
        state.propuestaAgencia = (/true/i).test(params.presupuesto.propuestaAgencia);
        state.usuario = params.presupuesto.usuario;
        state.usuarioCoordinadorId = params.presupuesto.usuarioCoordinadorId;
        state.usuarioCoordinador = params.presupuesto.usuarioCoordinador;
        state.usuarioCoordinadorNombre = params.presupuesto.usuarioCoordinador? params.presupuesto.usuarioCoordinador.nombre.trim() : null;
        state.autorizado = (/true/i).test(params.presupuesto.autorizado);
        state.usuarioAutorizacion = params.presupuesto.usuarioAutorizacion;
        state.fechaAutorizacion = moment(params.presupuesto.fechaAutorizacion).format('YYYY-MM-DD');
        state.rowVersion = params.presupuesto.rowVersion;

        /* Guardamos los parametros actuales que se actualizan al recuperar la info del cliente */
        state.pjeGastosFijosGlobal = parseFloat(params.presupuesto.pjeGastosFijos);
        state.pjeInversionFuturaGlobal = parseFloat(params.presupuesto.pjeInversionFutura);
        state.pjeImpuestosInternosGlobal = parseFloat(params.presupuesto.pjeImpuestosInternos);

        if (moment(params.presupuesto.fechaConfirmacion).format('YYYY-MM-DD') == EMPTY_DATE) {
            state.confirmado = false;
        } else {
            state.confirmado = true;
        }

        state.usuarios = state.usuariosList.map(usuario => ({
            ...usuario,
            asignado: false,
            _rowVariant: ''
        }));

        if (params.usuarios) {
            params.usuarios.forEach(usuario => {
                let selected = state.usuarios.find(t => t.usuarioId == usuario.usuarioId);
                if (selected) {
                    selected.asignado = true;
                } else {
                    /* Agregamos el usuario (inactivo) */
                    state.usuarios.push({
                        usuarioId: usuario.usuarioId,
                        usuario: usuario.usuario.trim(),
                        usuarioRolId: usuario.usuarioRolId,
                        usuarioRol: usuario.usuarioRol,
                        inactivo: usuario.inactivo,
                        asignado: true,
                        _rowVariant: usuario.inactivo? 'inactivo' : ''
                    })
                }
            });
        }

        /* Ordenamos la lista de usuarios */
        state.usuarios = state.usuarios.sort((a, b) => {
            // Inactivos al final
            if (a.inactivo !== b.inactivo) return a.inactivo ? 1 : -1;

            // Asignados al principio
            if (a.asignado !== b.asignado) return a.asignado ? -1 : 1;

            // Rol + nombre ordenados alfabéticamente
            const x = `${a.usuarioRol} ${a.usuario}`.toLowerCase().trim();
            const y = `${b.usuarioRol} ${b.usuario}`.toLowerCase().trim();
            return x.localeCompare(y);
        });

        state.facturacion = params.facturacion.map(facturacion => ({
                ...facturacion,
                id: helpers.methods.getUUID()
            }))
            .sort((a, b) => new Date(a.fechaFacturacion) - new Date(b.fechaFacturacion));

        state.provincias = state.provinciasList.map(provincia => ({
            provinciaId: provincia.id,
            provincia: provincia.nombre,
            seleccionada: false
        }));
        if (params.provincias) {
            params.provincias.forEach(provincia => {
                let selected = state.provincias.find(t => t.provinciaId == provincia.provinciaId);
                if (selected) {
                    selected.seleccionada = true;
                }
            });
        }

        state.usuariosPropuesta = state.usuariosList.map(usuario => ({
            ...usuario,
            asignado: false,
            _rowVariant: ''
        }));

        if (params.usuariosPropuesta) {
            params.usuariosPropuesta.forEach(usuario => {
                let selected = state.usuariosPropuesta.find(t => t.usuarioId == usuario.usuarioId);
                if (selected) {
                    selected.asignado = true;
                } else {
                    /* Agregamos el usuario (inactivo) */
                    state.usuariosPropuesta.push({
                        usuarioId: usuario.usuarioId,
                        usuario: usuario.usuario.trim(),
                        usuarioRolId: usuario.usuarioRolId,
                        usuarioRol: usuario.usuarioRol,
                        inactivo: usuario.inactivo,
                        asignado: true,
                        _rowVariant: usuario.inactivo? 'inactivo' : ''
                    })
                }
            });
        }

        /* Ordenamos la lista de usuarios de la propuesta */
        state.usuariosPropuesta = state.usuariosPropuesta.sort((a, b) => {
            // Inactivos al final
            if (a.inactivo !== b.inactivo) return a.inactivo ? 1 : -1;

            // Asignados al principio
            if (a.asignado !== b.asignado) return a.asignado ? -1 : 1;

            // Rol + nombre ordenados alfabéticamente
            const x = `${a.usuarioRol} ${a.usuario}`.toLowerCase().trim();
            const y = `${b.usuarioRol} ${b.usuario}`.toLowerCase().trim();
            return x.localeCompare(y);
        });

        /* Vendedores Comisiones */
        if (params.vendedoresComisiones) {
            if (params.vendedoresComisiones.length != 0) {
                state.vendedoresComisiones = params.vendedoresComisiones.map(vendedorComision => ({
                    id: helpers.methods.getUUID(),
                    vendedorId: (/true/i).test(state.accesoComisiones) ? vendedorComision.vendedorId : 0,
                    vendedor: (/true/i).test(state.accesoComisiones) ? vendedorComision.vendedor : null,
                    vendedorNombre: (/true/i).test(state.accesoComisiones) ? (vendedorComision.vendedor? vendedorComision.vendedor.nombre : null) : null,
                    personalId: (/true/i).test(state.accesoComisiones) ? vendedorComision.personalId : 0,
                    personal: (/true/i).test(state.accesoComisiones) ? vendedorComision.personal : null,
                    comisionInterna: vendedorComision.comisionInterna,
                    tipoComision: vendedorComision.tipoComision,
                    tipoPjeComision: vendedorComision.tipoPjeComision,
                    pjeComisionVendedor: parseFloat(vendedorComision.pjeComisionVendedor),
                    pjeFeeComisionVendedor: parseFloat(vendedorComision.pjeFeeComisionVendedor),
                    importeVendedor: parseFloat(vendedorComision.importeVendedor),
                    pjeComisionPresupuesto: parseFloat(vendedorComision.pjeComisionPresupuesto),
                    pjeFeeComisionPresupuesto: parseFloat(vendedorComision.pjeFeeComisionPresupuesto),
                    importePresupuesto: parseFloat(vendedorComision.importePresupuesto),
                    pjeComision: parseFloat(vendedorComision.pjeComision),
                    importe: parseFloat(vendedorComision.importe),
                    montoCancelado: parseFloat(vendedorComision.montoCancelado),
                    isFacturado: (/true/i).test(vendedorComision.isFacturado)
                })); 
            }
        }

        state.ordenesTrabajo = params.ordenesTrabajos.map(orden => ({
            id: helpers.methods.getUUID(),
            ordenTrabajoId: orden.ordenTrabajoId,
            rubroTrabajoId: parseInt(orden.rubroTrabajoId),
            rubroTrabajo: orden.rubroTrabajo,
            categoriaServicioId: parseInt(orden.categoriaServicioId),
            categoriaServicio: orden.categoriaServicio,
            titulo: orden.titulo.trim(),
            pjeRentabilidadMaxima: 0, //parseFloat(orden.pjeRentabilidadMaxima),
            pjeRentabilidadMinima: parseFloat(orden.pjeRentabilidadMinima),
            premios: (/true/i).test(orden.premios),
            reembolsos: (/true/i).test(orden.reembolsos),
            noAplicaFee: (/true/i).test(orden.noAplicaFee),
            excluidoComisiones: (/true/i).test(orden.excluidoComisiones),
            /* Parámetros para el cálculo del costo interno */
            parametrosGlobales: (/true/i).test(orden.parametrosGlobales),
            pjeGastosFijos: parseFloat(orden.pjeGastosFijos),
            pjeInversionFutura: parseFloat(orden.pjeInversionFutura),
            pjeImpuestosInternos: parseFloat(orden.pjeImpuestosInternos),
            descripcion: orden.descripcion.trim(),
            cantidad: parseFloat(orden.cantidad),
            monedaId: parseInt(orden.monedaId),
            moneda: orden.moneda,
            costoEstimado: parseFloat(orden.costoEstimado),
            costoEstimadoTotal: parseFloat(orden.costoEstimadoTotal),
            costoUnitario: (/true/i).test(orden.costoUnitario),
            costoInterno: parseFloat(orden.costoInterno),
            proveedorId: parseInt(orden.proveedorId),
            proveedor: orden.proveedor,
            costoProveedor: parseFloat(orden.costoProveedor),
            pjeRentabilidad: parseFloat(orden.pjeRentabilidad),
            cotizacionInterna: parseFloat(orden.cotizacionInterna),
            cotizacion: parseFloat(orden.cotizacion),
            importeDescuento: parseFloat(orden.importeDescuento),
            pjeRentabilidadDirty: false,
            certificado: (/true/i).test(orden.certificado),
            montoCertificado: parseFloat(orden.montoCertificado),
            tieneImagenes: (/true/i).test(orden.tieneImagenes),

            /* Alternativas */
            alternativas: orden.alternativas.map(alternativa => ({
                id: helpers.methods.getUUID(),
                ...alternativa,
                pjeRentabilidadDirty: false
            }))
        }));

        /* Monto total certificado */
        state.montoCertificado = state.ordenesTrabajo.reduce((total, orden) => {
            return total + parseFloat(orden.montoCertificado);
        }, 0);

        calcularTotales(state);
    },
    'INICIALIZAR_CLIENTE'(state) {
        state.clienteId = 0;
        state.cliente = null;
        state.clienteNombre = null;
        state.condicionFiscalId = 0;
    
        /* Inicializamos la información del contacto */
        state.clienteContactoId = 0;
        state.clienteContacto = null;
        state.clienteContactoNombre = null;

        /* Inicializamos la información de comisiones */
        state.vendedoresComisiones = [];

        /* Inicializamos los parametros de presupuestación */
        state.feeAgencia = 0;
        state.aplicarEscalaFee = false;
        state.escalasFee = [];
        state.feeAgenciaPremios = 0;
        state.discriminarFee = false;
        state.ocultarLeyendaFee = false;
        state.discriminarFeePremios = false;
        // state.feeComisionable = false;
        state.pjeFinanciacion = 0;
        state.aplicarEscalaFinanciacion = false;
        state.pjeFinanciacionCliente = 0;
        state.discriminarPjeFinanciacion = false;
        state.feeSobreFinanciacion = false;
        state.escalasFinanciacion = [];
        state.discriminarCategoriaServicio = false;
        state.servicioPropioNoAplicaFee = false;
        state.prontoPagoFeeDiferenciado = false;
        state.pjeRecargoServicioPropio = 0;
        state.pjeMargenMinimoCotizacion = 0;
        state.pjeMargenMinimoCotizacionPropio = 0;
        state.pjeMargenMinimoCotizacionTerceros = 0;
        state.seleccionProvincias = false;
        
        /* Recuperamos los valores de los parametros globales */
        state.pjeGastosFijos = state.pjeGastosFijosGlobal;
        state.pjeInversionFutura = state.pjeInversionFuturaGlobal;
        state.pjeImpuestosInternos = state.pjeImpuestosInternosGlobal;

        state.provincias = [];
        
        calcularTotales(state);
    },
    'SET_CLIENTE'(state, cliente) {
        state.clienteId = cliente.id;
        state.cliente = cliente;
        state.clienteNombre = cliente.nombreComercial.trim();
        state.condicionFiscalId = cliente.condicionFiscalId;

        state.feeAgencia = parseFloat(cliente.feeAgencia);
        state.aplicarEscalaFee = (/true/i).test(cliente.aplicarEscalaFee);
        state.escalasFee = cliente.escalasFee.map(escala => ({
            id: 0,
            montoMinimo: parseFloat(escala.montoMinimo),
            montoMaximo: parseFloat(escala.montoMaximo),
            pjeFeeAgencia: parseFloat(escala.pjeFeeAgencia),
        }));
        state.feeAgenciaPremios = parseFloat(cliente.feeAgenciaPremios);
        state.discriminarFee = (/true/i).test(cliente.discriminarFee);
        state.ocultarLeyendaFee = (/true/i).test(cliente.ocultarLeyendaFee);
        state.discriminarFeePremios = (/true/i).test(cliente.discriminarFeePremios);
        // state.feeComisionable = (/true/i).test(cliente.feeComisionable);
        state.pjeFinanciacion = parseFloat(cliente.pjeFinanciacion);
        state.aplicarEscalaFinanciacion = (/true/i).test(cliente.aplicarEscalaFinanciacion);
        state.pjeFinanciacionCliente = parseFloat(cliente.pjeFinanciacion);
        state.discriminarPjeFinanciacion = (/true/i).test(cliente.discriminarPjeFinanciacion);
        state.feeSobreFinanciacion = (/true/i).test(cliente.feeSobreFinanciacion);
        state.escalasFinanciacion = cliente.escalasFinanciacion.map(escala => ({
            id: 0,
            montoMinimo: parseFloat(escala.montoMinimo),
            montoMaximo: parseFloat(escala.montoMaximo),
            pjeFinanciacion: parseFloat(escala.pjeFinanciacion),
        }));
        state.discriminarCategoriaServicio = (/true/i).test(cliente.discriminarCategoriaServicio);
        state.servicioPropioNoAplicaFee = (/true/i).test(cliente.servicioPropioNoAplicaFee);
        state.prontoPagoFeeDiferenciado = (/true/i).test(cliente.prontoPagoFeeDiferenciado);
        state.pjeRecargoServicioPropio = parseFloat(cliente.pjeRecargoServicioPropio)
        state.pjeMargenMinimoCotizacion = parseFloat(cliente.pjeMargenMinimoCotizacion);
        state.pjeMargenMinimoCotizacionPropio = parseFloat(cliente.pjeMargenMinimoCotizacionPropio);
        state.pjeMargenMinimoCotizacionTerceros = parseFloat(cliente.pjeMargenMinimoCotizacionTerceros);
        state.seleccionProvincias = (/true/i).test(cliente.seleccionProvinciasPresupuestos);
        
        if ((/true/i).test(cliente.parametrosCostoInterno)) {
            state.pjeGastosFijos = cliente.pjeGastosFijos;
            state.pjeInversionFutura = cliente.pjeInversionFutura;
            state.pjeImpuestosInternos = cliente.pjeImpuestosInternos;
        }

        calcularTotales(state);
        
        if ((/true/i).test(cliente.seleccionProvinciasPresupuestos)) {
            state.provincias = state.provinciasList.map(provincia => ({
                provinciaId: provincia.id,
                provincia: provincia.nombre,
                seleccionada: false
            }));
        }
    },
    'CALCULAR_TOTALES'(state) {
        calcularTotales(state);
        
        if (state.ordenTrabajoAlternativas) {
            calcularTotalesOrden(state);
        }
    },
    'SET_TIPO_PRESUPUESTO'(state, tipoPresupuesto) {
        state.tipoPresupuesto = tipoPresupuesto;
        if (tipoPresupuesto) {
            state.tipoPresupuestoId = tipoPresupuesto.id? tipoPresupuesto.id : 0;
            state.tipoPresupuestoNombre = tipoPresupuesto.nombre? tipoPresupuesto.nombre.trim() : null;
        } else {
            state.tipoPresupuestoId = 0;
            state.tipoPresupuestoNombre = null;
        }
    },
    // 'SET_CLIENTE'(state, cliente) {
    //     state.cliente = cliente;
    //     if (cliente) {
    //         state.clienteId = cliente.id? cliente.id : 0;
    //         state.clienteNombre = cliente.nombre? cliente.nombre.trim() : null;
    //         state.condicionFiscalId = cliente.condicionFiscalId? cliente.condicionFiscalId : 0;
    //     } else {
    //         state.clienteId = 0;
    //         state.clienteNombre = null;
    //         state.condicionFiscalId = 0;
    //     }
        
    //     /* Inicializamos la información del contacto */
    //     state.clienteContactoId = 0;
    //     state.clienteContacto = null;
    //     state.clienteContactoNombre = null;
    // },
    'SET_CLIENTE_CONTACTO'(state, clienteContacto) {
        state.clienteContacto = clienteContacto;
        if (clienteContacto) {
            state.clienteContactoId = clienteContacto.id? clienteContacto.id : 0;
            state.clienteContactoNombre = clienteContacto.nombre? clienteContacto.nombre.trim() : null;
        } else {
            state.clienteContactoId = 0;
            state.clienteContactoNombre = null;
        }
    },
    'SET_PRIORIDAD'(state, prioridad) {
        state.prioridad = prioridad;
        if (prioridad) {
            state.prioridadId = prioridad.id? prioridad.id : 0;
            state.prioridadNombre = prioridad.nombre? prioridad.nombre.trim() : null;
        } else {
            state.prioridadId = 0;
            state.prioridadNombre = null;
        }
    },
    'SET_MONEDA'(state, moneda) {
        state.moneda = moneda;
        if (moneda) {
            state.monedaId = moneda.id? moneda.id : 0;
            state.monedaNombre = moneda.nombre? moneda.nombre.trim() : null;
        } else {
            state.monedaId = 0;
            state.monedaNombre = null;
        }
    },
    'SET_USUARIO_COORDINADOR'(state, usuarioCoordinador) {
        state.usuarioCoordinador = usuarioCoordinador;
        if (usuarioCoordinador) {
            state.usuarioCoordinadorId = usuarioCoordinador.id? usuarioCoordinador.id : 0;
            state.usuarioCoordinadorNombre = usuarioCoordinador.nombreCompleto? usuarioCoordinador.nombreCompleto.trim() : null;
        } else {
            state.usuarioCoordinadorId = 0;
            state.usuarioCoordinadorNombre = null;
        }
    },
    'SET_VENDEDOR_COMISION'(state, vendedorComision) {
        let pjeComision = 0;
        let importe = 0;

        switch (vendedorComision.tipoComision) {
            case 1: /* Porcentaje */
                switch (vendedorComision.tipoPjeComision) {
                    case 1: /* Porcentaje fijo */
                        pjeComision = vendedorComision.pjeComisionPresupuesto;
                        break;
                    case 2: /* Porcentaje sobre fee */
                        pjeComision = helpers.methods.roundToTwo(state.feeAgencia * vendedorComision.pjeFeeComisionPresupuesto / 100);
                        break;
                }
                importe = 0;
                break;

            case 2: /* Importe fijo */
                pjeComision = 0;
                importe = vendedorComision.importePresupuesto;
                break;

            case 3: /* Porcentaje + Importe */
                switch (vendedorComision.tipoPjeComision) {
                    case 1: /* Porcentaje fijo */
                        pjeComision = vendedorComision.pjeComisionPresupuesto;
                        break;
                    case 2: /* Porcentaje sobre fee */
                        pjeComision = helpers.methods.roundToTwo(state.feeAgencia * vendedorComision.pjeFeeComisionPresupuesto / 100);
                        break;
                }
                importe = vendedorComision.importePresupuesto;
                break;
        }

        let current = state.vendedoresComisiones.find(vc => vc.id == vendedorComision.id);
        if (current) {
            current.comisionInterna = vendedorComision.comisionInterna;
            current.tipoComision = vendedorComision.tipoComision;
            current.tipoPjeComision = vendedorComision.tipoPjeComision;
            current.pjeComisionVendedor = vendedorComision.pjeComisionVendedor;
            current.pjeFeeComisionVendedor = vendedorComision.pjeFeeComisionVendedor;
            current.importeVendedor = vendedorComision.importeVendedor;
            current.pjeComisionPresupuesto = vendedorComision.pjeComisionPresupuesto;
            current.pjeFeeComisionPresupuesto = vendedorComision.pjeFeeComisionPresupuesto;
            current.importePresupuesto = vendedorComision.importePresupuesto;
            current.pjeComision = pjeComision;
            current.importe = importe;
        } else {
            /* Agregamos el nuevo vendedor */
            const comision = {
                id: helpers.methods.getUUID(),
                vendedorId: vendedorComision.vendedorId || 0,
                vendedor: vendedorComision.vendedor,
                vendedorNombre: vendedorComision.vendedor ? vendedorComision.vendedor.nombre.trim() || '' : null,
                personalId: 0,
                personal: null,
    
                comisionInterna: vendedorComision.comisionInterna,
                tipoComision: vendedorComision.tipoComision,
                tipoPjeComision: vendedorComision.tipoPjeComision,
                pjeComisionVendedor: vendedorComision.pjeComisionVendedor,
                pjeFeeComisionVendedor: vendedorComision.pjeFeeComisionVendedor,
                importeVendedor: vendedorComision.importeVendedor,
                pjeComisionPresupuesto: vendedorComision.pjeComisionPresupuesto,
                pjeFeeComisionPresupuesto: vendedorComision.pjeFeeComisionPresupuesto,
                importePresupuesto: vendedorComision.importePresupuesto,
                pjeComision: pjeComision,
                importe: importe,
                montoCancelado: 0,
                isFacturado: false
            }
    
            state.vendedoresComisiones.push(comision);
        }

    },
    'SET_VENDEDOR_COMISION_CLIENTE'(state, vendedorComision) {
        let pjeComision = 0;
        let importe = 0;

        switch (vendedorComision.tipoComision) {
            case 1: /* Porcentaje */
                switch (vendedorComision.tipoPjeComision) {
                    case 1: /* Porcentaje fijo */
                        pjeComision = vendedorComision.pjeComisionVendedor;
                        break;
                    case 2: /* Porcentaje sobre fee */
                        pjeComision = helpers.methods.roundToTwo(state.feeAgencia * vendedorComision.pjeFeeComisionVendedor / 100);
                        break;
                }
                importe = 0;
                break;

            case 2: /* Importe fijo */
                pjeComision = 0;
                importe = vendedorComision.importeVendedor;
                break;

            case 3: /* Porcentaje + Importe */
                switch (vendedorComision.tipoPjeComision) {
                    case 1: /* Porcentaje fijo */
                        pjeComision = vendedorComision.pjeComisionVendedor;
                        break;
                    case 2: /* Porcentaje sobre fee */
                        pjeComision = helpers.methods.roundToTwo(state.feeAgencia * vendedorComision.pjeFeeComisionVendedor / 100);
                        break;
                }
                importe = vendedorComision.importeVendedor;
                break;
        }

        const comision = {
            id: helpers.methods.getUUID(),
            vendedorId: vendedorComision.vendedorId || 0,
            vendedor: vendedorComision.vendedor,
            vendedorNombre: vendedorComision.vendedor ? vendedorComision.vendedor.nombre.trim() || '' : null,
            personalId: 0,
            personal: null,

            comisionInterna: vendedorComision.comisionInterna,
            tipoComision: vendedorComision.tipoComision,
            tipoPjeComision: vendedorComision.tipoPjeComision,
            pjeComisionVendedor: vendedorComision.pjeComisionVendedor,
            pjeFeeComisionVendedor: vendedorComision.pjeFeeComisionVendedor,
            importeVendedor: vendedorComision.importeVendedor,
            pjeComisionPresupuesto: vendedorComision.pjeComisionVendedor,
            pjeFeeComisionPresupuesto: vendedorComision.pjeFeeComisionVendedor,
            importePresupuesto: vendedorComision.importeVendedor,
            pjeComision: pjeComision,
            importe: importe,
            montoCancelado: 0,
            isFacturado: false
        }
        
        state.vendedoresComisiones.push(comision);
    },
    'DELETE_VENDEDOR_COMISION'(state, vendedorComisionId) {
        state.vendedoresComisiones = state.vendedoresComisiones.filter(vc => vc.id !== vendedorComisionId);
    },
    'UPDATE_PJE_COMISION' (state) {
        if (Array.isArray(state.vendedoresComisiones) && state.vendedoresComisiones.length > 0) {
            state.vendedoresComisiones.forEach(vendedorComision => {
                if (vendedorComision.tipoComision == 1 || vendedorComision.tipoComision == 3) {
                    if (vendedorComision.tipoPjeComision == 2) {
                        vendedorComision.pjeComision = helpers.methods.roundToTwo(state.feeAgencia * vendedorComision.pjeFeeComisionVendedor / 100);
                    }
                }
            });
        }
    },

    'SELECT_ORDEN' (state, ordenTrabajo) {
        state.ordenTrabajoSeleccionada = ordenTrabajo;
    },
    'ADD_ORDEN' (state, orden) {
        /* Calculamos el costo interno */
        let pjeGastosFijos = parseFloat(state.pjeGastosFijos);
        let pjeInversionFutura = parseFloat(state.pjeInversionFutura);
        let pjeImpuestosInternos = parseFloat(state.pjeImpuestosInternos);

        if (!orden.parametrosGlobales) {
            pjeGastosFijos = parseFloat(orden.pjeGastosFijos);
            pjeInversionFutura = parseFloat(orden.pjeInversionFutura);
            pjeImpuestosInternos = parseFloat(orden.pjeImpuestosInternos);
        }

        let costoInterno = parseFloat(orden.costoEstimadoTotal) 
            + (parseFloat(orden.costoEstimadoTotal) * parseFloat(pjeGastosFijos) / 100) 
            + (parseFloat(orden.costoEstimadoTotal) * parseFloat(pjeInversionFutura) / 100)
            + (parseFloat(orden.costoEstimadoTotal) * parseFloat(pjeImpuestosInternos) / 100);

        /* Rentabilidad a partir de la cotización */
        let cotizacionInterna = 0;
        
        if (orden.pjeRentabilidad != 0) {
            cotizacionInterna = Math.ceil(parseFloat(costoInterno) / (1 - parseFloat(orden.pjeRentabilidad) / 100));
        }
        
        /* Misma moneda presupuesto y orden de trabajo */
        if (orden.monedaId != state.monedaId) {
            if (state.monedaId == 101) {
                /* Presupuesto en $ */
                let costoInternoPesos = parseFloat(costoInterno) * parseFloat(state.monedaCotizacion);
                
                /* Rentabilidad a partir de la cotización */
                if (orden.pjeRentabilidad != 0) {
                    cotizacionInterna = Math.ceil(parseFloat(costoInternoPesos) / (1 - parseFloat(orden.pjeRentabilidad) / 100));
                }
            } else {
                /* Presupuesto en usd o eur */
                let costoInternoUsd = parseFloat(costoInterno) / parseFloat(state.monedaCotizacion);

                /* Rentabilidad a partir de la cotización */
                if (orden.pjeRentabilidad != 0) {
                    cotizacionInterna = Math.ceil(parseFloat(costoInternoUsd) / (1 - parseFloat(orden.pjeRentabilidad) / 100));
                }
            }
        }

        let cotizacion = cotizacionInterna;

        if (orden.categoriaServicioId == 1) {
            if (state.pjeRecargoServicioPropio != 0) {
                cotizacion = Math.ceil(parseFloat(cotizacionInterna) 
                    + (parseFloat(cotizacionInterna) * parseFloat(state.pjeRecargoServicioPropio) / 100));
            }
        }

        state.ordenesTrabajo.push({
            id: helpers.methods.getUUID(),
            ordenTrabajoId: 0,
            rubroTrabajoId: parseInt(orden.rubroTrabajoId),
            rubroTrabajo: orden.rubroTrabajo,
            categoriaServicioId: parseInt(orden.categoriaServicioId),
            categoriaServicio: orden.categoriaServicio,
            titulo: orden.titulo.trim(),
            pjeRentabilidadMaxima: 0, 
            pjeRentabilidadMinima: parseFloat(orden.pjeRentabilidadMinima),
            premios: (/true/i).test(orden.premios),
            reembolsos: (/true/i).test(orden.reembolsos),
            noAplicaFee: (/true/i).test(orden.noAplicaFee),
            excluidoComisiones: (/true/i).test(orden.excluidoComisiones),
            /* Parámetros para el cálculo del costo interno */
            parametrosGlobales: (/true/i).test(orden.parametrosGlobales),
            pjeGastosFijos: parseFloat(orden.pjeGastosFijos),
            pjeInversionFutura: parseFloat(orden.pjeInversionFutura),
            pjeImpuestosInternos: parseFloat(orden.pjeImpuestosInternos),
            descripcion: orden.descripcion.trim(),
            cantidad: parseFloat(orden.cantidad),
            monedaId: parseInt(orden.monedaId),
            moneda: orden.moneda,
            costoEstimado: parseFloat(orden.costoEstimado),
            costoEstimadoTotal: parseFloat(orden.costoEstimadoTotal),
            costoUnitario: (/true/i).test(orden.costoUnitario),
            costoInterno: parseFloat(costoInterno),
            pjeRentabilidad: parseFloat(orden.pjeRentabilidad),
            cotizacionInterna: parseFloat(cotizacionInterna),
            cotizacion: parseFloat(cotizacion),
            importeDescuento: 0, //parseFloat(orden.importeDescuento),
            pjeRentabilidadDirty: Boolean(true),
            certificado: Boolean(false),
            montoCertificado: 0,
            tieneImagenes: Boolean(false),

            proveedorId: parseInt(orden.proveedorId),
            proveedor: orden.proveedor,
            costoProveedor: parseFloat(orden.costoProveedor),

            alternativas: []
        });

        calcularTotales(state);
    },
    'UPDATE_ORDEN' (state, orden) {
        /* Calculamos el costo interno */
        let pjeGastosFijos = parseFloat(state.pjeGastosFijos);
        let pjeInversionFutura = parseFloat(state.pjeInversionFutura);
        let pjeImpuestosInternos = parseFloat(state.pjeImpuestosInternos);

        if (!orden.parametrosGlobales) {
            pjeGastosFijos = parseFloat(orden.pjeGastosFijos);
            pjeInversionFutura = parseFloat(orden.pjeInversionFutura);
            pjeImpuestosInternos = parseFloat(orden.pjeImpuestosInternos);
        }

        let costoInterno = parseFloat(orden.costoEstimadoTotal)
            + (parseFloat(orden.costoEstimadoTotal) * parseFloat(pjeGastosFijos) / 100) 
            + (parseFloat(orden.costoEstimadoTotal) * parseFloat(pjeInversionFutura) / 100)
            + (parseFloat(orden.costoEstimadoTotal) * parseFloat(pjeImpuestosInternos) / 100);

        state.ordenTrabajoSeleccionada.rubroTrabajoId = orden.rubroTrabajo.id;
        state.ordenTrabajoSeleccionada.rubroTrabajo = {
            id: parseInt(orden.rubroTrabajo.id),
            nombre: orden.rubroTrabajo.nombre.trim().toUpperCase(),
            descripcion: orden.rubroTrabajo.descripcion.trim()
        };
        state.ordenTrabajoSeleccionada.categoriaServicioId = orden.categoriaServicio? orden.categoriaServicio.id : 0;
        if (orden.categoriaServicio) {
            state.ordenTrabajoSeleccionada.categoriaServicio = {
                id: parseInt(orden.categoriaServicio.id),
                nombre: orden.categoriaServicio.nombre.trim().toUpperCase()
            };
    
        } else {
            state.ordenTrabajoSeleccionada.categoriaServicio = null;
        }
        
        state.ordenTrabajoSeleccionada.pjeRentabilidadMaxima = 0; //parseFloat(orden.pjeRentabilidadMaxima);
        state.ordenTrabajoSeleccionada.pjeRentabilidadMinima = parseFloat(orden.pjeRentabilidadMinima);
        state.ordenTrabajoSeleccionada.premios = (/true/i).test(orden.premios);
        state.ordenTrabajoSeleccionada.reembolsos = (/true/i).test(orden.reembolsos);
        state.ordenTrabajoSeleccionada.noAplicaFee = (/true/i).test(orden.noAplicaFee);
        state.ordenTrabajoSeleccionada.excluidoComisiones = (/true/i).test(orden.excluidoComisiones);
        /* Parámetros para el cálculo del costo interno */
        state.ordenTrabajoSeleccionada.parametrosGlobales = (/true/i).test(orden.parametrosGlobales);
        state.ordenTrabajoSeleccionada.pjeGastosFijos = parseFloat(orden.pjeGastosFijos);
        state.ordenTrabajoSeleccionada.pjeInversionFutura = parseFloat(orden.pjeInversionFutura);
        state.ordenTrabajoSeleccionada.pjeImpuestosInternos = parseFloat(orden.pjeImpuestosInternos);
        state.ordenTrabajoSeleccionada.monedaId = parseInt(orden.monedaId);
        state.ordenTrabajoSeleccionada.moneda = orden.moneda;

        state.ordenTrabajoSeleccionada.proveedorId = parseInt(orden.proveedorId);
        state.ordenTrabajoSeleccionada.proveedor = orden.proveedor;
        state.ordenTrabajoSeleccionada.costoProveedor = parseFloat(orden.costoProveedor);
        
        state.ordenTrabajoSeleccionada.titulo = orden.titulo.trim();
        state.ordenTrabajoSeleccionada.descripcion = orden.descripcion.trim();
        state.ordenTrabajoSeleccionada.costoEstimado = parseFloat(orden.costoEstimado);
        state.ordenTrabajoSeleccionada.costoEstimadoTotal = parseFloat(orden.costoEstimadoTotal);
        state.ordenTrabajoSeleccionada.costoUnitario = (/true/i).test(orden.costoUnitario);
        state.ordenTrabajoSeleccionada.cantidad = parseFloat(orden.cantidad);

        state.ordenTrabajoSeleccionada.costoInterno = parseFloat(costoInterno);
        
        /* Actualizamos el pje de rentabilidad y la cotización */
        /* Rentabilidad a partir de la cotización */
        state.ordenTrabajoSeleccionada.pjeRentabilidad = 0;
        state.ordenTrabajoSeleccionada.pjeRentabilidadDirty = Boolean(true);

        if (costoInterno != 0) {
            if (state.ordenTrabajoSeleccionada.cotizacionInterna != 0) {
                if (state.ordenTrabajoSeleccionada.monedaId == state.monedaId) {
                    /* Misma moneda */
                    state.ordenTrabajoSeleccionada.pjeRentabilidad = helpers.methods.roundToTwo((state.ordenTrabajoSeleccionada.cotizacionInterna - state.ordenTrabajoSeleccionada.costoInterno) / state.ordenTrabajoSeleccionada.cotizacionInterna * 100);
                } else {
                    if (state.monedaId == 101) {
                        /* Presupuesto en $ */
                        let costoPesos = parseFloat(state.ordenTrabajoSeleccionada.costoInterno) * parseFloat(state.monedaCotizacion);
                        state.ordenTrabajoSeleccionada.pjeRentabilidad = helpers.methods.roundToTwo((state.ordenTrabajoSeleccionada.cotizacionInterna - costoPesos) / state.ordenTrabajoSeleccionada.cotizacionInterna * 100);
                    } else {
                        /* Presupuesto en usd o eur */
                        let cotizacionPesos = helpers.methods.roundToTwo(parseFloat(state.ordenTrabajoSeleccionada.cotizacionInterna) * parseFloat(state.monedaCotizacion));
                        state.ordenTrabajoSeleccionada.pjeRentabilidad = helpers.methods.roundToTwo((cotizacionPesos - state.ordenTrabajoSeleccionada.costoInterno) / cotizacionPesos * 100);
                    }
                }
            }
        }

        /* Verificamos si tiene alternativas y actualizamos la seleccionada */
        if (state.ordenTrabajoSeleccionada.alternativas) {
            if (state.ordenTrabajoSeleccionada.alternativas.length != 0) {
                let seleccionada = state.ordenTrabajoSeleccionada.alternativas.find(alternativa => alternativa.seleccionada == true);
                if (seleccionada) {
                    seleccionada.titulo = state.ordenTrabajoSeleccionada.titulo.trim();
                    seleccionada.descripcion = state.ordenTrabajoSeleccionada.descripcion.trim();
                    seleccionada.costoEstimado = parseFloat(state.ordenTrabajoSeleccionada.costoEstimado);
                    seleccionada.costoEstimadoTotal = parseFloat(state.ordenTrabajoSeleccionada.costoEstimadoTotal);
                    seleccionada.costoUnitario = (/true/i).test(state.ordenTrabajoSeleccionada.costoUnitario);
                    seleccionada.cantidad = parseFloat(state.ordenTrabajoSeleccionada.cantidad);
                    seleccionada.costoInterno = parseFloat(state.ordenTrabajoSeleccionada.costoInterno);
                    seleccionada.pjeRentabilidad = parseFloat(state.ordenTrabajoSeleccionada.pjeRentabilidad);
                    seleccionada.cotizacionInterna = parseFloat(state.ordenTrabajoSeleccionada.cotizacionInterna);
                    seleccionada.cotizacion = parseFloat(state.ordenTrabajoSeleccionada.cotizacion);

                    calcularTotalesOrden(state);
                }
            }
        }

        calcularTotales(state);
    },
    'UPDATE_ORDEN_PJE_RENTABILIDAD' (state, params) {
        state.ordenTrabajoSeleccionada = state.ordenesTrabajo
            .find( ordenTrabajo => ordenTrabajo.id == params.ordenTrabajoId);

        if (state.ordenTrabajoSeleccionada.pjeRentabilidad != params.pjeRentabilidad) {
            state.ordenTrabajoSeleccionada.pjeRentabilidad = parseFloat(params.pjeRentabilidad);
            state.ordenTrabajoSeleccionada.pjeRentabilidadDirty = Boolean(true);

            /* Rentabilidad a partir de la cotización */
            state.ordenTrabajoSeleccionada.cotizacionInterna = 0;
            
            if (parseFloat(params.pjeRentabilidad) != 0) {
                let cotizacion = Math.ceil(parseFloat(state.ordenTrabajoSeleccionada.costoInterno) / (1 - parseFloat(params.pjeRentabilidad) / 100));

                if (state.ordenTrabajoSeleccionada.monedaId == state.monedaId) {
                    /* Misma moneda */
                    state.ordenTrabajoSeleccionada.cotizacionInterna = cotizacion;
                } else {
                    if (state.monedaId == 101) {
                        /* Presupuesto en $ */
                        state.ordenTrabajoSeleccionada.cotizacionInterna = helpers.methods.roundToTwo(parseFloat(cotizacion) * parseFloat(state.monedaCotizacion));
                    } else {
                        /* Presupuesto en usd o eur */
                        state.ordenTrabajoSeleccionada.cotizacionInterna = helpers.methods.roundToTwo(parseFloat(cotizacion) / parseFloat(state.monedaCotizacion));
                    }
                }
            }

            /* Calculamos la cotizacion a partir de la cotizacion interna */
            state.ordenTrabajoSeleccionada.cotizacion = state.ordenTrabajoSeleccionada.cotizacionInterna;

            if (state.ordenTrabajoSeleccionada.categoriaServicioId == 1) {
                if (state.pjeRecargoServicioPropio != 0) {
                    state.ordenTrabajoSeleccionada.cotizacion = Math.ceil(parseFloat(state.ordenTrabajoSeleccionada.cotizacionInterna) 
                        + (parseFloat(state.ordenTrabajoSeleccionada.cotizacionInterna) * parseFloat(state.pjeRecargoServicioPropio) / 100));
                }
            }
        }

        /* Verificamos si tiene alternativas y actualizamos la seleccionada */
        if (state.ordenTrabajoSeleccionada.alternativas) {
            if (state.ordenTrabajoSeleccionada.alternativas.length != 0) {
                let seleccionada = state.ordenTrabajoSeleccionada.alternativas.find(alternativa => alternativa.seleccionada == true);
                if (seleccionada) {
                    seleccionada.pjeRentabilidad = parseFloat(state.ordenTrabajoSeleccionada.pjeRentabilidad);
                    seleccionada.cotizacionInterna = parseFloat(state.ordenTrabajoSeleccionada.cotizacionInterna);
                    seleccionada.cotizacion = parseFloat(state.ordenTrabajoSeleccionada.cotizacion);

                    calcularTotalesOrden(state);
                }
            }
        }
        
        calcularTotales(state);
    },
    'AJUSTAR_MONTO_CERTIFICADO' (state, ordenTrabajo) {
        if (state.pjeDescuento != 0) {
            return;
        }

        state.ordenTrabajoSeleccionada = ordenTrabajo;

        let montoCertificado = ordenTrabajo.montoCertificado;
        
        if (state.pjeDescuento != 0) {
            /* Calculamos el monto certificado con el descuento aplicado */
            montoCertificado = helpers.methods.roundToTwo( parseFloat(montoCertificado) * (1 + parseFloat(state.pjeDescuento)) );
            
            /* Descontamos el descuento de la orden */
            montoCertificado -=  parseFloat(state.ordenTrabajoSeleccionada.importeDescuento);
        }

        state.ordenTrabajoSeleccionada.cotizacion = parseFloat(montoCertificado);
        /* Calcular a partir del pje de recargo */
        state.ordenTrabajoSeleccionada.cotizacionInterna = parseFloat(montoCertificado);

        /* Rentabilidad a partir de la cotización */
        state.ordenTrabajoSeleccionada.pjeRentabilidad = 0;
        state.ordenTrabajoSeleccionada.pjeRentabilidadDirty = Boolean(true);

        if (montoCertificado != 0) {
            if (state.ordenTrabajoSeleccionada.monedaId == state.monedaId) {
                /* Misma moneda */
                state.ordenTrabajoSeleccionada.pjeRentabilidad = helpers.methods.roundToTwo((montoCertificado - state.ordenTrabajoSeleccionada.costoInterno) / montoCertificado * 100); 
            } else {
                if (state.monedaId == 101) {
                    /* Presupuesto en $ */
                    let costoPesos = parseFloat(state.ordenTrabajoSeleccionada.costoInterno) * parseFloat(state.monedaCotizacion);
                    state.ordenTrabajoSeleccionada.pjeRentabilidad = helpers.methods.roundToTwo((montoCertificado - costoPesos) / montoCertificado * 100); 
                } else {
                    /* Presupuesto en usd o eur */
                    let cotizacionPesos = helpers.methods.roundToTwo(parseFloat(montoCertificado) * parseFloat(state.monedaCotizacion));
                    state.ordenTrabajoSeleccionada.pjeRentabilidad = helpers.methods.roundToTwo((cotizacionPesos - state.ordenTrabajoSeleccionada.costoInterno) / cotizacionPesos * 100); 
                }
            }
        }

        /* Verificamos si tiene alternativas y actualizamos la seleccionada */
        if (state.ordenTrabajoSeleccionada.alternativas) {
            if (state.ordenTrabajoSeleccionada.alternativas.length != 0) {
                let seleccionada = state.ordenTrabajoSeleccionada.alternativas.find(alternativa => alternativa.seleccionada == true);
                if (seleccionada) {
                    seleccionada.pjeRentabilidad = parseFloat(state.ordenTrabajoSeleccionada.pjeRentabilidad);
                    seleccionada.cotizacionInterna = parseFloat(state.ordenTrabajoSeleccionada.cotizacionInterna);
                    seleccionada.cotizacion = parseFloat(state.ordenTrabajoSeleccionada.cotizacion);

                    calcularTotalesOrden(state);
                }
            }
        }

        calcularTotales(state);
    },
    'UPDATE_ORDEN_COTIZACION' (state, params) {
        state.ordenTrabajoSeleccionada = state.ordenesTrabajo
            .find( ordenTrabajo => ordenTrabajo.id == params.ordenTrabajoId);

        state.ordenTrabajoSeleccionada.cotizacion = parseFloat(params.cotizacion);
        
        /* Calcular a partir del pje de recargo */
        state.ordenTrabajoSeleccionada.cotizacionInterna = parseFloat(params.cotizacion);

        /* Rentabilidad a partir de la cotización */
        state.ordenTrabajoSeleccionada.pjeRentabilidad = 0;
        state.ordenTrabajoSeleccionada.pjeRentabilidadDirty = Boolean(true);

        if (params.cotizacion != 0) {
            if (state.ordenTrabajoSeleccionada.monedaId == state.monedaId) {
                /* Misma moneda */
                state.ordenTrabajoSeleccionada.pjeRentabilidad = helpers.methods.roundToTwo((params.cotizacion - state.ordenTrabajoSeleccionada.costoInterno) / params.cotizacion * 100); 
            } else {
                if (state.monedaId == 101) {
                    /* Presupuesto en $ */
                    let costoPesos = parseFloat(state.ordenTrabajoSeleccionada.costoInterno) * parseFloat(state.monedaCotizacion);
                    state.ordenTrabajoSeleccionada.pjeRentabilidad = helpers.methods.roundToTwo((params.cotizacion - costoPesos) / params.cotizacion * 100); 
                } else {
                    /* Presupuesto en usd o eur */
                    let cotizacionPesos = helpers.methods.roundToTwo(parseFloat(params.cotizacion) * parseFloat(state.monedaCotizacion));
                    state.ordenTrabajoSeleccionada.pjeRentabilidad = helpers.methods.roundToTwo((cotizacionPesos - state.ordenTrabajoSeleccionada.costoInterno) / cotizacionPesos * 100); 
                }
            }
        }

        /* Verificamos si tiene alternativas y actualizamos la seleccionada */
        if (state.ordenTrabajoSeleccionada.alternativas) {
            if (state.ordenTrabajoSeleccionada.alternativas.length != 0) {
                let seleccionada = state.ordenTrabajoSeleccionada.alternativas.find(alternativa => alternativa.seleccionada == true);
                if (seleccionada) {
                    seleccionada.pjeRentabilidad = parseFloat(state.ordenTrabajoSeleccionada.pjeRentabilidad);
                    seleccionada.cotizacionInterna = parseFloat(state.ordenTrabajoSeleccionada.cotizacionInterna);
                    seleccionada.cotizacion = parseFloat(state.ordenTrabajoSeleccionada.cotizacion);

                    calcularTotalesOrden(state);
                }
            }
        }

        calcularTotales(state);
    },
    'UPDATE_ORDEN_COTIZACION_INTERNA' (state, params) {
        state.ordenTrabajoSeleccionada = state.ordenesTrabajo
            .find( ordenTrabajo => ordenTrabajo.id == params.ordenTrabajoId);

        state.ordenTrabajoSeleccionada.cotizacionInterna = parseFloat(params.cotizacion);
        
        /* Calculamos la cotizacion a partir de la cotizacion interna */
        state.ordenTrabajoSeleccionada.cotizacion = parseFloat(params.cotizacion);

        if (state.ordenTrabajoSeleccionada.categoriaServicioId == 1) {
            if (state.pjeRecargoServicioPropio != 0) {
                state.ordenTrabajoSeleccionada.cotizacion = Math.ceil(parseFloat(params.cotizacion) 
                    + (parseFloat(params.cotizacion) * parseFloat(state.pjeRecargoServicioPropio) / 100));
            }
        }

        /* Rentabilidad a partir de la cotización */
        state.ordenTrabajoSeleccionada.pjeRentabilidad = 0;
        state.ordenTrabajoSeleccionada.pjeRentabilidadDirty = Boolean(true);

        if (params.cotizacion != 0) {
            if (state.ordenTrabajoSeleccionada.monedaId == state.monedaId) {
                /* Misma moneda */
                state.ordenTrabajoSeleccionada.pjeRentabilidad = helpers.methods.roundToTwo((params.cotizacion - state.ordenTrabajoSeleccionada.costoInterno) / params.cotizacion * 100); 
            } else {
                if (state.monedaId == 101) {
                    /* Presupuesto en $ */
                    let costoPesos = parseFloat(state.ordenTrabajoSeleccionada.costoInterno) * parseFloat(state.monedaCotizacion);
                    state.ordenTrabajoSeleccionada.pjeRentabilidad = helpers.methods.roundToTwo((params.cotizacion - costoPesos) / params.cotizacion * 100); 
                } else {
                    /* Presupuesto en usd o eur */
                    let cotizacionPesos = helpers.methods.roundToTwo(parseFloat(params.cotizacion) * parseFloat(state.monedaCotizacion));
                    state.ordenTrabajoSeleccionada.pjeRentabilidad = helpers.methods.roundToTwo((cotizacionPesos - state.ordenTrabajoSeleccionada.costoInterno) / cotizacionPesos * 100); 
                }
            }
        }

        /* Verificamos si tiene alternativas y actualizamos la seleccionada */
        if (state.ordenTrabajoSeleccionada.alternativas) {
            if (state.ordenTrabajoSeleccionada.alternativas.length != 0) {
                let seleccionada = state.ordenTrabajoSeleccionada.alternativas.find(alternativa => alternativa.seleccionada == true);
                if (seleccionada) {
                    seleccionada.pjeRentabilidad = parseFloat(state.ordenTrabajoSeleccionada.pjeRentabilidad);
                    seleccionada.cotizacionInterna = parseFloat(state.ordenTrabajoSeleccionada.cotizacionInterna);
                    seleccionada.cotizacion = parseFloat(state.ordenTrabajoSeleccionada.cotizacion);

                    calcularTotalesOrden(state);
                }
            }
        }

        calcularTotales(state);
    },
    'UPDATE_DESCUENTO_ORDEN' (state, params) {
        state.ordenTrabajoSeleccionada = state.ordenesTrabajo
            .find( ordenTrabajo => ordenTrabajo.id == params.ordenTrabajoId);

        state.ordenTrabajoSeleccionada.importeDescuento = parseFloat(params.importeDescuento);
        
        calcularTotales(state);
    },
    'DELETE_ORDEN' (state, ordenTrabajoId) {
        let itemKey = state.ordenesTrabajo
            .findIndex(ordenTrabajo => ordenTrabajo.id == ordenTrabajoId);

        if (itemKey != -1) {
            state.ordenesTrabajo.splice(itemKey, 1);
            state.ordenTrabajoSeleccionada = null;
        }

        calcularTotales(state);
    },
    'SET_TIENE_IMAGEN' (state, params) {
        let item = state.ordenesTrabajo
            .find(orden => orden.ordenTrabajoId == params.ordenTrabajoId);

        if (item) {
            item.tieneImagenes = (/true/i).test(params.tieneImagenes);
        }

        calcularTotales(state);
    },

    'CONSULTAR_ALTERNATIVAS' (state, ordenTrabajo) {
        state.ordenTrabajoAlternativas = ordenTrabajo;
        
        calcularTotalesOrden(state);
    },
    'CLEAR_CONSULTA_ALTERNATIVAS' (state) {
        state.ordenTrabajoAlternativas = null;

        calcularTotalesOrden(state);
    },
    'SELECT_ORDEN_ALTERNATIVA' (state, ordenTrabajoAlternativa) {
        state.ordenTrabajoAlternativaSeleccionada = ordenTrabajoAlternativa;
    },
    'ADD_ORDEN_ALTERNATIVA' (state, ordenTrabajoAlternativa) {
        let addOrden = true;
        if (state.ordenTrabajoSeleccionada.alternativas) {
            if (state.ordenTrabajoSeleccionada.alternativas.length != 0) {
                addOrden = false;
            }
        }

        /* Agregamos como alternativa inicial (seleccionada) a la orden */
        if (addOrden) {
            state.ordenTrabajoSeleccionada.alternativas.push({
                id: helpers.methods.getUUID(),
                titulo: state.ordenTrabajoSeleccionada.titulo.trim(),
                descripcion: state.ordenTrabajoSeleccionada.descripcion.trim(),
                cantidad: state.ordenTrabajoSeleccionada.cantidad,
                costoEstimado: state.ordenTrabajoSeleccionada.costoEstimado,
                costoEstimadoTotal: state.ordenTrabajoSeleccionada.costoEstimadoTotal,
                costoUnitario: state.ordenTrabajoSeleccionada.costoUnitario,
                costoInterno: state.ordenTrabajoSeleccionada.costoInterno,
                pjeRentabilidad: state.ordenTrabajoSeleccionada.pjeRentabilidad,
                cotizacionInterna: state.ordenTrabajoSeleccionada.cotizacionInterna,
                cotizacion: state.ordenTrabajoSeleccionada.cotizacion,
                seleccionada: true
            })
        }

        /* Calculamos el costo interno */
        let pjeGastosFijos = parseFloat(state.pjeGastosFijos);
        let pjeInversionFutura = parseFloat(state.pjeInversionFutura);
        let pjeImpuestosInternos = parseFloat(state.pjeImpuestosInternos);

        if (!state.ordenTrabajoSeleccionada.parametrosGlobales) {
            pjeGastosFijos = parseFloat(state.ordenTrabajoSeleccionada.pjeGastosFijos);
            pjeInversionFutura = parseFloat(state.ordenTrabajoSeleccionada.pjeInversionFutura);
            pjeImpuestosInternos = parseFloat(state.ordenTrabajoSeleccionada.pjeImpuestosInternos);
        }

        let costoInterno = parseFloat(ordenTrabajoAlternativa.costoEstimadoTotal) 
            + (parseFloat(ordenTrabajoAlternativa.costoEstimadoTotal) * parseFloat(pjeGastosFijos) / 100) 
            + (parseFloat(ordenTrabajoAlternativa.costoEstimadoTotal) * parseFloat(pjeInversionFutura) / 100)
            + (parseFloat(ordenTrabajoAlternativa.costoEstimadoTotal) * parseFloat(pjeImpuestosInternos) / 100);

        /* Rentabilidad a partir de la cotización */
        let cotizacionInterna = 0;
        
        if (state.ordenTrabajoSeleccionada.pjeRentabilidad != 0) {
            cotizacionInterna = Math.ceil(parseFloat(costoInterno) / (1 - parseFloat(state.ordenTrabajoSeleccionada.pjeRentabilidad) / 100));
        }
            
        /* Misma moneda presupuesto y orden de trabajo */
        if (state.ordenTrabajoSeleccionada != state.monedaId) {
            if (state.monedaId == 101) {
                /* Presupuesto en $ */
                let costoInternoPesos = parseFloat(costoInterno) * parseFloat(state.monedaCotizacion);

                /* Rentabilidad a partir de la cotización */
                if (state.ordenTrabajoSeleccionada.pjeRentabilidad != 0) {
                    cotizacionInterna = Math.ceil(parseFloat(costoInternoPesos) / (1 - parseFloat(state.ordenTrabajoSeleccionada.pjeRentabilidad) / 100));
                }
            } else {
                /* Presupuesto en usd o eur */
                let costoInternoUsd = parseFloat(costoInterno) / parseFloat(state.monedaCotizacion);

                /* Rentabilidad a partir de la cotización */
                if (state.ordenTrabajoSeleccionada.pjeRentabilidad != 0) {
                    cotizacionInterna = Math.ceil(parseFloat(costoInternoUsd) / (1 - parseFloat(state.ordenTrabajoSeleccionada.pjeRentabilidad) / 100));
                }
            }
        }
                
        let cotizacion = cotizacionInterna;
        if (state.ordenTrabajoSeleccionada.categoriaServicioId == 1) {
            if (state.pjeRecargoServicioPropio != 0) {
                cotizacion = Math.ceil(parseFloat(cotizacionInterna) 
                    + (parseFloat(cotizacionInterna) * parseFloat(state.pjeRecargoServicioPropio) / 100));
            }
        }

        state.ordenTrabajoSeleccionada.alternativas.push({
            id: helpers.methods.getUUID(),
            ordenTrabajoAlternativaId: 0,
            rubroTrabajoId: parseInt(state.ordenTrabajoSeleccionada.rubroTrabajoId),
            rubroTrabajo: state.ordenTrabajoSeleccionada.rubroTrabajo,
            categoriaServicioId: parseInt(state.ordenTrabajoSeleccionada.categoriaServicioId),
            categoriaServicio: state.ordenTrabajoSeleccionada.categoriaServicio,

            pjeRentabilidadMaxima: 0, 
            pjeRentabilidadMinima: parseFloat(state.ordenTrabajoSeleccionada.pjeRentabilidadMinima),
            premios: (/true/i).test(state.ordenTrabajoSeleccionada.premios),
            reembolsos: (/true/i).test(state.ordenTrabajoSeleccionada.reembolsos),
            noAplicaFee: (/true/i).test(state.ordenTrabajoSeleccionada.noAplicaFee),
            excluidoComisiones: (/true/i).test(state.ordenTrabajoSeleccionada.excluidoComisiones),
            /* Parámetros para el cálculo del costo interno */
            parametrosGlobales: (/true/i).test(state.ordenTrabajoSeleccionada.parametrosGlobales),
            pjeGastosFijos: parseFloat(state.ordenTrabajoSeleccionada.pjeGastosFijos),
            pjeInversionFutura: parseFloat(state.ordenTrabajoSeleccionada.pjeInversionFutura),
            pjeImpuestosInternos: parseFloat(state.ordenTrabajoSeleccionada.pjeImpuestosInternos),

            monedaId: parseInt(state.ordenTrabajoSeleccionada.monedaId),
            moneda: state.ordenTrabajoSeleccionada.moneda,
            pjeRentabilidad: parseFloat(state.ordenTrabajoSeleccionada.pjeRentabilidad),
            pjeRentabilidadDirty: Boolean(true),

            titulo: ordenTrabajoAlternativa.titulo.trim(),
            descripcion: ordenTrabajoAlternativa.descripcion.trim(),
            cantidad: parseFloat(ordenTrabajoAlternativa.cantidad),
            costoEstimado: parseFloat(ordenTrabajoAlternativa.costoEstimado),
            costoEstimadoTotal: parseFloat(ordenTrabajoAlternativa.costoEstimadoTotal),
            costoUnitario: (/true/i).test(ordenTrabajoAlternativa.costoUnitario),
            costoInterno: parseFloat(costoInterno),
            cotizacionInterna: parseFloat(cotizacionInterna),
            cotizacion: parseFloat(cotizacion),

            certificado: Boolean(false),
            montoCertificado: 0,
            tieneImagenes: Boolean(false),
            seleccionada: Boolean(false),

            proveedorId: 0,
            proveedor: null,
            costoProveedor: 0,
        });

        let ordenSeleccionadaDatos = state.ordenesTrabajoDatos.find(orden => orden.id == state.ordenTrabajoSeleccionada.id);
        if (ordenSeleccionadaDatos) {
            ordenSeleccionadaDatos.tieneAlternativas = true;
        }

        /* Consultamos las alternativas de la orden */
        state.ordenTrabajoAlternativas = state.ordenTrabajoSeleccionada;

        calcularTotalesOrden(state);
    },
    'UPDATE_ORDEN_ALTERNATIVA' (state, ordenTrabajoAlternativa) {
        /* Calculamos el costo interno */
        let pjeGastosFijos = parseFloat(state.pjeGastosFijos);
        let pjeInversionFutura = parseFloat(state.pjeInversionFutura);
        let pjeImpuestosInternos = parseFloat(state.pjeImpuestosInternos);

        if (!state.ordenTrabajoAlternativas.parametrosGlobales) {
            pjeGastosFijos = parseFloat(state.ordenTrabajoAlternativas.pjeGastosFijos);
            pjeInversionFutura = parseFloat(state.ordenTrabajoAlternativas.pjeInversionFutura);
            pjeImpuestosInternos = parseFloat(state.ordenTrabajoAlternativas.pjeImpuestosInternos);
        }

        let costoInterno = parseFloat(ordenTrabajoAlternativa.costoEstimadoTotal)
            + (parseFloat(ordenTrabajoAlternativa.costoEstimadoTotal) * parseFloat(pjeGastosFijos) / 100) 
            + (parseFloat(ordenTrabajoAlternativa.costoEstimadoTotal) * parseFloat(pjeInversionFutura) / 100)
            + (parseFloat(ordenTrabajoAlternativa.costoEstimadoTotal) * parseFloat(pjeImpuestosInternos) / 100);

        state.ordenTrabajoAlternativaSeleccionada.titulo = ordenTrabajoAlternativa.titulo.trim();
        state.ordenTrabajoAlternativaSeleccionada.descripcion = ordenTrabajoAlternativa.descripcion.trim();
        state.ordenTrabajoAlternativaSeleccionada.costoEstimado = parseFloat(ordenTrabajoAlternativa.costoEstimado);
        state.ordenTrabajoAlternativaSeleccionada.costoEstimadoTotal = parseFloat(ordenTrabajoAlternativa.costoEstimadoTotal);
        state.ordenTrabajoAlternativaSeleccionada.costoUnitario = (/true/i).test(ordenTrabajoAlternativa.costoUnitario);
        state.ordenTrabajoAlternativaSeleccionada.cantidad = parseFloat(ordenTrabajoAlternativa.cantidad);

        state.ordenTrabajoAlternativaSeleccionada.costoInterno = parseFloat(costoInterno);
        /* Actualizamos el pje de rentabilidad y la cotización */
        /* Rentabilidad a partir de la cotización */
        state.ordenTrabajoAlternativaSeleccionada.pjeRentabilidad = 0;
        state.ordenTrabajoAlternativaSeleccionada.pjeRentabilidadDirty = Boolean(true);

        if (costoInterno != 0) {
            if (state.ordenTrabajoAlternativaSeleccionada.cotizacionInterna != 0) {
                if (state.ordenTrabajoAlternativas.monedaId == state.monedaId) {
                    /* Misma moneda */
                    state.ordenTrabajoAlternativaSeleccionada.pjeRentabilidad = helpers.methods.roundToTwo((state.ordenTrabajoAlternativaSeleccionada.cotizacionInterna - state.ordenTrabajoAlternativaSeleccionada.costoInterno) / state.ordenTrabajoAlternativaSeleccionada.cotizacionInterna * 100);
                } else {
                    if (state.monedaId == 101) {
                        /* Presupuesto en $ */
                        let costoPesos = parseFloat(state.ordenTrabajoAlternativaSeleccionada.costoInterno) * parseFloat(state.monedaCotizacion);
                        state.ordenTrabajoAlternativaSeleccionada.pjeRentabilidad = helpers.methods.roundToTwo((state.ordenTrabajoAlternativaSeleccionada.cotizacionInterna - costoPesos) / state.ordenTrabajoAlternativaSeleccionada.cotizacionInterna * 100);
                    } else {
                        /* Presupuesto en usd o eur */
                        let cotizacionPesos = helpers.methods.roundToTwo(parseFloat(state.ordenTrabajoAlternativaSeleccionada.cotizacionInterna) * parseFloat(state.monedaCotizacion));
                        state.ordenTrabajoAlternativaSeleccionada.pjeRentabilidad = helpers.methods.roundToTwo((cotizacionPesos - state.ordenTrabajoAlternativaSeleccionada.costoInterno) / cotizacionPesos * 100);
                    }
                }
            }
        }

        /* Si es la alternativa seleccionada, actualizamos la orden */
        if ((/true/i).test(state.ordenTrabajoAlternativaSeleccionada.seleccionada)) {
            state.ordenTrabajoAlternativas.titulo = state.ordenTrabajoAlternativaSeleccionada.titulo.trim();
            state.ordenTrabajoAlternativas.descripcion = state.ordenTrabajoAlternativaSeleccionada.descripcion.trim();
            state.ordenTrabajoAlternativas.cantidad = parseFloat(state.ordenTrabajoAlternativaSeleccionada.cantidad);
            state.ordenTrabajoAlternativas.costoEstimado = parseFloat(state.ordenTrabajoAlternativaSeleccionada.costoEstimado);
            state.ordenTrabajoAlternativas.costoEstimadoTotal = parseFloat(state.ordenTrabajoAlternativaSeleccionada.costoEstimadoTotal);
            state.ordenTrabajoAlternativas.costoUnitario = (/true/i).test(state.ordenTrabajoAlternativaSeleccionada.costoUnitario);
            state.ordenTrabajoAlternativas.costoInterno = parseFloat(state.ordenTrabajoAlternativaSeleccionada.costoInterno);
            state.ordenTrabajoAlternativas.pjeRentabilidad = state.ordenTrabajoAlternativaSeleccionada.pjeRentabilidad;
            state.ordenTrabajoAlternativas.cotizacionInterna = state.ordenTrabajoAlternativaSeleccionada.cotizacionInterna;
            state.ordenTrabajoAlternativas.cotizacion = state.ordenTrabajoAlternativaSeleccionada.cotizacion;
        }

        calcularTotalesOrden(state);
        calcularTotales(state);
    },
    'DELETE_ORDEN_ALTERNATIVA' (state, ordenTrabajoAlternativaId) {
        let itemKey = state.ordenTrabajoAlternativas.alternativas
            .findIndex(ordenTrabajoAlternativa => ordenTrabajoAlternativa.id == ordenTrabajoAlternativaId);

        if (itemKey != -1) {
            state.ordenTrabajoAlternativas.alternativas.splice(itemKey, 1);
            state.ordenTrabajoAlternativaSeleccionada = null;
        }

        let ordenSeleccionadaDatos = state.ordenesTrabajoDatos.find(orden => orden.id == state.ordenTrabajoAlternativas.id);
        if (ordenSeleccionadaDatos) {
            ordenSeleccionadaDatos.tieneAlternativas = state.ordenTrabajoAlternativas.alternativas.length != 0;
        }

        calcularTotalesOrden(state);
    },
    'SELECCIONAR_ORDEN_ALTERNATIVA' (state, ordenTrabajoAlternativa) {
        state.ordenTrabajoAlternativas.titulo = ordenTrabajoAlternativa.titulo;
        state.ordenTrabajoAlternativas.descripcion = ordenTrabajoAlternativa.descripcion;
        state.ordenTrabajoAlternativas.cantidad = ordenTrabajoAlternativa.cantidad;
        state.ordenTrabajoAlternativas.costoEstimado = ordenTrabajoAlternativa.costoEstimado;
        state.ordenTrabajoAlternativas.costoEstimadoTotal = ordenTrabajoAlternativa.costoEstimadoTotal;
        state.ordenTrabajoAlternativas.costoUnitario = ordenTrabajoAlternativa.costoUnitario;
        state.ordenTrabajoAlternativas.costoInterno = ordenTrabajoAlternativa.costoInterno;
        state.ordenTrabajoAlternativas.pjeRentabilidad = ordenTrabajoAlternativa.pjeRentabilidad;
        state.ordenTrabajoAlternativas.cotizacionInterna = ordenTrabajoAlternativa.cotizacionInterna;
        state.ordenTrabajoAlternativas.cotizacion = ordenTrabajoAlternativa.cotizacion;
        
        let seleccionada = state.ordenTrabajoAlternativas.alternativas.find(alternativa => alternativa.seleccionada == true);
        if (seleccionada) {
            seleccionada.seleccionada = false;
        }

        ordenTrabajoAlternativa.seleccionada = true;

        calcularTotalesOrden(state);
        calcularTotales(state);
    },
    'UPDATE_ORDEN_ALTERNATIVA_PJE_RENTABILIDAD' (state, params) {
        let ordenTrabajoAlternativa = state.ordenTrabajoAlternativas.alternativas
            .find(ordenTrabajoAlternativa => ordenTrabajoAlternativa.id.toString().trim() == params.ordenTrabajoAlternativaId.toString().trim());

        if (ordenTrabajoAlternativa) {

            if (ordenTrabajoAlternativa.pjeRentabilidad != params.pjeRentabilidad) {
                ordenTrabajoAlternativa.pjeRentabilidad = parseFloat(params.pjeRentabilidad);
                ordenTrabajoAlternativa.pjeRentabilidadDirty = Boolean(true);

                /* Rentabilidad a partir de la cotización */
                ordenTrabajoAlternativa.cotizacionInterna = 0;
                
                if (parseFloat(params.pjeRentabilidad) != 0) {
                    let cotizacion = Math.ceil(parseFloat(ordenTrabajoAlternativa.costoInterno) / (1 - parseFloat(params.pjeRentabilidad) / 100));

                    if (ordenTrabajoAlternativa.monedaId == state.monedaId) {
                        /* Misma moneda */
                        ordenTrabajoAlternativa.cotizacionInterna = cotizacion;
                    } else {
                        if (state.monedaId == 101) {
                            /* Presupuesto en $ */
                            ordenTrabajoAlternativa.cotizacionInterna = helpers.methods.roundToTwo(parseFloat(cotizacion) * parseFloat(state.monedaCotizacion));
                        } else {
                            /* Presupuesto en usd o eur */
                            ordenTrabajoAlternativa.cotizacionInterna = helpers.methods.roundToTwo(parseFloat(cotizacion) / parseFloat(state.monedaCotizacion));
                        }
                    }
                }

                /* Calculamos la cotizacion a partir de la cotizacion interna */
                ordenTrabajoAlternativa.cotizacion = ordenTrabajoAlternativa.cotizacionInterna;
                if (ordenTrabajoAlternativa.categoriaServicioId == 1) {
                    if (state.pjeRecargoServicioPropio != 0) {
                        ordenTrabajoAlternativa.cotizacion = Math.ceil(parseFloat(ordenTrabajoAlternativa.cotizacionInterna) 
                            + (parseFloat(ordenTrabajoAlternativa.cotizacionInterna) * parseFloat(state.pjeRecargoServicioPropio) / 100));
                    }
                }
            }
    
            /* Si es la alternativa seleccionada, actualizamos la orden */
            if ((/true/i).test(ordenTrabajoAlternativa.seleccionada)) {
                state.ordenTrabajoAlternativas.pjeRentabilidad = ordenTrabajoAlternativa.pjeRentabilidad;
                state.ordenTrabajoAlternativas.cotizacionInterna = ordenTrabajoAlternativa.cotizacionInterna;
                state.ordenTrabajoAlternativas.cotizacion = ordenTrabajoAlternativa.cotizacion;
            }
    
            calcularTotalesOrden(state);
            calcularTotales(state);
        }
    },
    'UPDATE_ORDEN_ALTERNATIVA_COTIZACION' (state, params) {
        let ordenTrabajoAlternativa = state.ordenTrabajoAlternativas.alternativas
            .find(ordenTrabajoAlternativa => ordenTrabajoAlternativa.id.toString().trim() == params.ordenTrabajoAlternativaId.toString().trim());

        if(ordenTrabajoAlternativa) {

            ordenTrabajoAlternativa.cotizacion = parseFloat(params.cotizacion);
            
            /* Calcular a partir del pje de recargo */
            ordenTrabajoAlternativa.cotizacionInterna = parseFloat(params.cotizacion);
    
            /* Rentabilidad a partir de la cotización */
            ordenTrabajoAlternativa.pjeRentabilidad = 0;
            ordenTrabajoAlternativa.pjeRentabilidadDirty = Boolean(true);

            if (params.cotizacion != 0) {
                if (ordenTrabajoAlternativa.monedaId == state.monedaId) {
                    /* Misma moneda */
                    ordenTrabajoAlternativa.pjeRentabilidad = helpers.methods.roundToTwo((params.cotizacion - ordenTrabajoAlternativa.costoInterno) / params.cotizacion * 100); 
                } else {
                    if (state.monedaId == 101) {
                        /* Presupuesto en $ */
                        let costoPesos = parseFloat(ordenTrabajoAlternativa.costoInterno) * parseFloat(state.monedaCotizacion);
                        ordenTrabajoAlternativa.pjeRentabilidad = helpers.methods.roundToTwo((params.cotizacion - costoPesos) / params.cotizacion * 100); 
                    } else {
                        /* Presupuesto en usd o eur */
                        let cotizacionPesos = helpers.methods.roundToTwo(parseFloat(params.cotizacion) * parseFloat(state.monedaCotizacion));
                        ordenTrabajoAlternativa.pjeRentabilidad = helpers.methods.roundToTwo((cotizacionPesos - ordenTrabajoAlternativa.costoInterno) / cotizacionPesos * 100); 
                    }
                }
            }
    
            /* Si es la alternativa seleccionada, actualizamos la orden */
            if ((/true/i).test(ordenTrabajoAlternativa.seleccionada)) {
                state.ordenTrabajoAlternativas.pjeRentabilidad = ordenTrabajoAlternativa.pjeRentabilidad;
                state.ordenTrabajoAlternativas.cotizacionInterna = ordenTrabajoAlternativa.cotizacionInterna;
                state.ordenTrabajoAlternativas.cotizacion = ordenTrabajoAlternativa.cotizacion;
            }
    
            calcularTotalesOrden(state);
            calcularTotales(state);
        }
    },
    'UPDATE_ORDEN_ALTERNATIVA_COTIZACION_INTERNA' (state, params) {
        let ordenTrabajoAlternativa = state.ordenTrabajoAlternativas.alternativas
            .find(ordenTrabajoAlternativa => ordenTrabajoAlternativa.id.toString().trim() == params.ordenTrabajoAlternativaId.toString().trim());
        
        if (ordenTrabajoAlternativa) {

            ordenTrabajoAlternativa.cotizacionInterna = parseFloat(params.cotizacion);
            
            /* Calculamos la cotizacion a partir de la cotizacion interna */
            ordenTrabajoAlternativa.cotizacion = parseFloat(params.cotizacion);
            if (ordenTrabajoAlternativa.categoriaServicioId == 1) {
                if (state.pjeRecargoServicioPropio != 0) {
                    ordenTrabajoAlternativa.cotizacion = Math.ceil(parseFloat(params.cotizacion) 
                        + (parseFloat(params.cotizacion) * parseFloat(state.pjeRecargoServicioPropio) / 100));
                }
            }
    
            /* Rentabilidad a partir de la cotización */
            ordenTrabajoAlternativa.pjeRentabilidad = 0;
            ordenTrabajoAlternativa.pjeRentabilidadDirty = Boolean(true);

            if (params.cotizacion != 0) {
                if (ordenTrabajoAlternativa.monedaId == state.monedaId) {
                    /* Misma moneda */
                    ordenTrabajoAlternativa.pjeRentabilidad = helpers.methods.roundToTwo((params.cotizacion - ordenTrabajoAlternativa.costoInterno) / params.cotizacion * 100); 
                } else {
                    if (state.monedaId == 101) {
                        /* Presupuesto en $ */
                        let costoPesos = parseFloat(ordenTrabajoAlternativa.costoInterno) * parseFloat(state.monedaCotizacion);
                        ordenTrabajoAlternativa.pjeRentabilidad = helpers.methods.roundToTwo((params.cotizacion - costoPesos) / params.cotizacion * 100); 
                    } else {
                        /* Presupuesto en usd o eur */
                        let cotizacionPesos = helpers.methods.roundToTwo(parseFloat(params.cotizacion) * parseFloat(state.monedaCotizacion));
                        ordenTrabajoAlternativa.pjeRentabilidad = helpers.methods.roundToTwo((cotizacionPesos - ordenTrabajoAlternativa.costoInterno) / cotizacionPesos * 100); 
                    }
                }
            }

            /* Si es la alternativa seleccionada, actualizamos la orden */
            if ((/true/i).test(ordenTrabajoAlternativa.seleccionada)) {
                state.ordenTrabajoAlternativas.pjeRentabilidad = ordenTrabajoAlternativa.pjeRentabilidad;
                state.ordenTrabajoAlternativas.cotizacionInterna = ordenTrabajoAlternativa.cotizacionInterna;
                state.ordenTrabajoAlternativas.cotizacion = ordenTrabajoAlternativa.cotizacion;
            }
    
            calcularTotalesOrden(state);
            calcularTotales(state);
        }
    },

    'INICIALIZAR_SEARCH' (state) {
        state.presupuestoSearch = {};
        state.ordenesListSearch = [];
        state.ordenesListSearchLogistica = false;
    },
    'SET_PRESUPUESTO_SEARCH' (state, params) {
        state.presupuestoSearch = params.presupuestoInterno;
        state.ordenesListSearchLogistica = (/true/i).test(params.logistica);
        
        if (state.presupuestoSearch.ordenesTrabajos) {
            setOrdenesTrabajosListSearch(state);
        }
    },
    'ADD_SUBTRABAJO_SEARCH' (state, params) {
        let ordenTrabajo = state.presupuestoSearch.ordenesTrabajos.find(ordenTrabajo => ordenTrabajo.id == params.ordenTrabajoId);
        if (ordenTrabajo) {
            ordenTrabajo.subtrabajos.push(params.ordenSubtrabajo);
        }
        setOrdenesTrabajosListSearch(state);
    },

    'SET_IMAGENES' (state, imagenes) {
        state.imagenes = imagenes;
    },

    'ADD_FECHA_FACTURACION' (state, facturacion) {
        let key = state.facturacion.findIndex(t => t.fechaFacturacion == facturacion.fechaFacturacion);

        if (key == -1) {
            state.facturacion.push({
                id: helpers.methods.getUUID(),
                fechaFacturacion: facturacion.fechaFacturacion,
                importeFacturacion: parseFloat(facturacion.importeFacturacion),
            });

            state.facturacion = state.facturacion.sort((a, b) => new Date(a.fechaFacturacion) - new Date(b.fechaFacturacion));
        }
    },
    'UPDATE_FECHA_FACTURACION' (state, facturacion) {
        let item = state.facturacion.find(t => t.id == facturacion.id);

        if (item) {
            item.fechaFacturacion = facturacion.fechaFacturacion;
            item.importeFacturacion = parseFloat(facturacion.importeFacturacion);
        }
    },
    'REMOVE_FECHA_FACTURACION' (state, facturacionId) {
        let key = state.facturacion.findIndex(t => t.id == facturacionId);

        if (key != -1) {
            state.facturacion.splice(key, 1);
        }
    }
};

function setOrdenesTrabajosListSearch(state) {
    state.ordenesListSearch = [];
    state.presupuestoSearch.ordenesTrabajos.forEach(ordenTrabajo => {
        state.ordenesListSearch.push(ordenTrabajo.id.toString().trim() + ' - ' + ordenTrabajo.titulo.trim());

        if ((/true/i).test(state.ordenesListSearchLogistica)) {
            ordenTrabajo.subtrabajosList = [];
            ordenTrabajo.subtrabajos.forEach(subtrabajo => {
                if ((/true/i).test(subtrabajo.logistica)) {
                    ordenTrabajo.subtrabajosList.push(subtrabajo.id.toString().trim() + ' - ' + subtrabajo.articuloTipo.trim())
                }
            });
        } else {
            ordenTrabajo.subtrabajosList = ordenTrabajo.subtrabajos.map( subtrabajo => 
                subtrabajo.id.toString().trim() + ' - ' + subtrabajo.articuloTipo.trim());
        }
    });
}

function setValoresIniciales(state) {    
    state.prioridadId= 3;
    state.prioridad= {
        id: 3,
        nombre: 'NORMAL'
    };
    state.prioridadNombre= 'NORMAL';
    state.monedaId= 101;
    state.moneda= {
        id: 101,
        nombre: 'PESOS'
    };
    state.monedaNombre= 'PESOS';
    state.monedaCotizacion = 1;
}

function calcularTotales (state) {
    state.ordenesTrabajoDatos = [];
    
    let totalCostoPesos = 0;
    let totalCotizacionBruta = 0;
    let totalDescuentoOrdenes = 0;
    let totalCotizacion = 0;
    let subtotalRebate = 0;
    let totalFinanciacion = 0;
    let totalFee = 0;
    let subtotal = 0;
    let totalNeto = 0;

    let totalCostoPesosSinReembolsos = 0;
    let totalCotizacionSinReembolsos = 0;
    let totalFinanciacionSinReembolsos = 0;
    let totalFeeSinReembolsos = 0;
    let totalNetoSinReembolsos = 0;

    let montoBaseComision = 0;

    let monedaCotizacion = 1;
    if (state.monedaCotizacion) {
        monedaCotizacion = parseFloat(state.monedaCotizacion);
    }

    /* Calculamos el pje de descuento de rebate (sobre cotización sin fee ni financiación) */
    /* Cotizacion = Cotizacion - ImporteDescuento */
    const cotizacion = state.ordenesTrabajo.reduce((total, orden) => {
            return total + parseFloat(orden.cotizacion) - parseFloat(orden.importeDescuento);
        }, 0);

    let pjeDescuentoRebate = 0;
    if (cotizacion != 0 && state.importeDescuentoRebate != 0) {
        pjeDescuentoRebate = parseFloat(state.importeDescuentoRebate) / parseFloat(cotizacion);
    }

    if (!state.confirmado && state.presupuestoInternoInicialId == 0) {
        /* Verificamos si aplica un pje de fee según una escala */
        if ((/true/i).test(state.aplicarEscalaFee)) {
            let totalCotizacion = 0;
            
            state.ordenesTrabajo.forEach(orden => {
                let aplicaFeeOrden = true;
        
                /* Servicio propio (según condición del cliente aplica o no fee) */
                if ((/true/i).test(state.servicioPropioNoAplicaFee)) {
                    if (orden.categoriaServicioId == 1) {
                        aplicaFeeOrden = false;
                    }
                }
                
                /* Según condición del rubro para el cliente aplica o no fee */
                if ((/true/i).test(orden.noAplicaFee)) {
                    aplicaFeeOrden = false;
                }
                
                /* Analizar casos de feeSobreFinanciacion */
                if (aplicaFeeOrden) {
                    let cotizacionOrden = parseFloat(orden.cotizacion) - parseFloat(orden.importeDescuento);
                    
                    if ((/true/i).test(state.discriminarFeePremios)) {
                        if ((/true/i).test(orden.premios)) {
                            cotizacionOrden = 0;
                        }
                    }
                    
                    totalCotizacion += cotizacionOrden;
                }
            })

            /* Verificamos la escala correspondiente */
            state.escalasFee.forEach(escala => {
                if (totalCotizacion >= escala.montoMinimo
                        && (totalCotizacion < escala.montoMaximo + 1 || escala.montoMaximo == 0)) {
                    state.feeAgencia = escala.pjeFeeAgencia;
                }
            });
        }
    }
    
    if (!state.confirmado && state.presupuestoInternoInicialId == 0) {
        /* Verificamos si aplica un pje de financiación según una escala */
        if ((/true/i).test(state.aplicarEscalaFinanciacion)) {
            let totalCotizacionFinanciacion = 0;
            
            state.ordenesTrabajo.forEach(orden => {
                /* Cotizacion = Cotizacion - ImporteDescuento */
                let cotizacionOrden = parseFloat(orden.cotizacion) - parseFloat(orden.importeDescuento);
                
                /* Calculo la cotización con el descuento de rebate incluido */
                if (pjeDescuentoRebate != 0) {
                    cotizacionOrden -= helpers.methods.roundToTwo(parseFloat(orden.cotizacion) * parseFloat(pjeDescuentoRebate));
                }
                
                totalCotizacionFinanciacion += cotizacionOrden;
            })

            /* Verificamos la escala correspondiente */
            state.escalasFinanciacion.forEach(escala => {
                if (totalCotizacionFinanciacion >= escala.montoMinimo
                        && (totalCotizacionFinanciacion < escala.montoMaximo + 1 || escala.montoMaximo == 0)) {
                    state.pjeFinanciacion = escala.pjeFinanciacion;
                }
            });
        }
    }

    state.ordenesTrabajo.forEach(orden => {
        /* Cotizacion = Cotizacion - ImporteDescuento */
        let cotizacionOrden = parseFloat(orden.cotizacion) - parseFloat(orden.importeDescuento);
        
        /* Calculo la cotización con el descuento de rebate incluido */
        if (pjeDescuentoRebate != 0) {
            cotizacionOrden -= helpers.methods.roundToTwo(parseFloat(orden.cotizacion) * parseFloat(pjeDescuentoRebate));
        }

        /* Calculo Fee + Financiacion */ 
        /* Aplico el pje de financiación sobre la cotización con descuento */
        let importeFinanciacionOrden = parseFloat(cotizacionOrden) * parseFloat(state.pjeFinanciacion) / 100;

        let importeFeeAgenciaOrden = 0;
        let aplicarFeeOrden = true;

        /* Servicio propio (según condición del cliente aplica o no fee) */
        if ((/true/i).test(state.servicioPropioNoAplicaFee)) {
            if (orden.categoriaServicioId == 1) {
                aplicarFeeOrden = false;
            }
        }

        /* Según condición del rubro para el cliente aplica o no fee */
        if ((/true/i).test(orden.noAplicaFee)) {
            aplicarFeeOrden = false;
        }

        if (aplicarFeeOrden) {
            let feeAgenciaOrden = parseFloat(state.feeAgencia);
            if ((/true/i).test(state.discriminarFeePremios)) {
                if ((/true/i).test(orden.premios)) {
                    feeAgenciaOrden = parseFloat(state.feeAgenciaPremios);
                }
            }
            
            /* Calculo sobre la cotización con el descuento de rebate incluido */
            if ((/true/i).test(state.feeSobreFinanciacion)) {
                /*  Calculamos el pje de fee sobre la cotizacion + el pje de financiacion */
                importeFeeAgenciaOrden = (parseFloat(cotizacionOrden) + parseFloat(importeFinanciacionOrden)) 
                    * parseFloat(feeAgenciaOrden) / 100;
            } else {
                importeFeeAgenciaOrden = parseFloat(cotizacionOrden) * parseFloat(feeAgenciaOrden) / 100;
            }
        }

        /* Validamos si el rubro esta excluido de las comisiones */
        if (!(/true/i).test(orden.excluidoComisiones)) {
            montoBaseComision += parseFloat(cotizacionOrden);
        }
        
        /* Cotización final (c/fee y financiación) */
        /* Cotización con el descuento de rebate incluido */
        /* Cotizacion = Cotizacion - ImporteDescuento */
        let cotizacionFinal = helpers.methods.roundToTwo(parseFloat(cotizacionOrden) 
            + parseFloat(importeFinanciacionOrden)
            + parseFloat(importeFeeAgenciaOrden));

        state.ordenesTrabajoDatos.push({
            id: orden.id,
            ordenTrabajoId: orden.ordenTrabajoId,
            ordenTrabajo: orden,

            rubroTrabajo: orden.rubroTrabajo? orden.rubroTrabajo.nombre.trim() : null,
            categoriaServicioId: orden.categoriaServicioId,
            categoriaServicio: orden.categoriaServicio? orden.categoriaServicio.nombre.trim() : null,
            titulo: orden.titulo.trim(),
            cantidad: orden.cantidad,
            moneda: orden.moneda? orden.moneda.nombre.trim() : null,
            costoEstimado: orden.costoEstimado,
            pjeRentabilidad: orden.pjeRentabilidad,
            pjeRentabilidadInvalido: orden.pjeRentabilidadInvalido,
            costoInterno: orden.costoInterno,
            cotizacionInterna: orden.cotizacionInterna,
            cotizacion: orden.cotizacion,
            importeDescuento: orden.importeDescuento,

            cotizacionFinal,
            
            /* Detalles de la orden de trabajo */
            _showDetails : Boolean(true),
            /* Determina si se certifico el renglon (total o parcialmente) */
            certificado: Boolean(orden.certificado),
            /* Monto certificado */
            montoCertificado: parseFloat(orden.montoCertificado),
            /* Determina si tiene imagenes */
            tieneImagenes: Boolean(orden.tieneImagenes),

            cotizacionInternaDisabled: state.pjeRecargoServicioPropio == 0,
            cotizacionDisabled: state.pjeRecargoServicioPropio != 0,

            tieneAlternativas: orden.alternativas.length != 0,

            _rowVariant: ''
        });
        
        /* Subtotal sin descuentos */
        /* Cotizacion = Cotizacion - ImporteDescuento */
        subtotal += parseFloat(orden.cotizacion) - parseFloat(orden.importeDescuento);

        /* Subtotal con descuento de rebate */
        subtotalRebate += parseFloat(cotizacionOrden);

        /* Calculo Fee + Financiacion */ 
        // let importeFinanciacion = parseFloat(orden.cotizacion) * parseFloat(state.pjeFinanciacion) / 100;
        /* Calculamos sobre la cotización con descuento de rebate (sobre cotización sin fee ni financiación) */
        /* Cotizacion = Cotizacion - ImporteDescuento */
        let importeFinanciacion = parseFloat(cotizacionOrden) * parseFloat(state.pjeFinanciacion) / 100;

        let importeFeeAgencia = 0;

        let aplicarFee = true;

        /* Servicio propio (según condición del cliente aplica o no fee) */
        if ((/true/i).test(state.servicioPropioNoAplicaFee)) {
            if (orden.categoriaServicioId == 1) {
                aplicarFee = false;
            }
        }

        /* Según condición del rubro para el cliente aplica o no fee */
        if ((/true/i).test(orden.noAplicaFee)) {
            aplicarFee = false;
        }

        if (aplicarFee) {
            let feeAgencia = parseFloat(state.feeAgencia);
            if ((/true/i).test(state.discriminarFeePremios)) {
                if ((/true/i).test(orden.premios)) {
                    feeAgencia = parseFloat(state.feeAgenciaPremios);
                }
            }

            /* Calculamos sobre la cotización con descuento de rebate (sobre cotización sin fee ni financiación) */
            /* Cotizacion = Cotizacion - ImporteDescuento */
            if ((/true/i).test(state.feeSobreFinanciacion)) {
                /*  Calculamos el pje de fee sobre la cotizacion + el pje de financiacion */
                importeFeeAgencia = (parseFloat(cotizacionOrden) + parseFloat(importeFinanciacion)) 
                    * parseFloat(feeAgencia) / 100;
            } else {
                importeFeeAgencia = parseFloat(cotizacionOrden) * parseFloat(feeAgencia) / 100;
            }
        }

        totalCotizacionBruta += parseFloat(orden.cotizacion);
        totalDescuentoOrdenes += parseFloat(orden.importeDescuento);

        /* Totales en la moneda del PI */
        /* Cotizacion = Cotizacion - ImporteDescuento */
        totalCotizacion += parseFloat(orden.cotizacion) - parseFloat(orden.importeDescuento);

        totalFinanciacion += parseFloat(importeFinanciacion);
        totalFee += parseFloat(importeFeeAgencia);

        /* Total neto con descuento de rebate */
        totalNeto += helpers.methods.roundToTwo(parseFloat(cotizacionOrden) 
            + parseFloat(importeFinanciacion)
            + parseFloat(importeFeeAgencia));

        /* Costo total en $ */
        let costoPesos = parseFloat(orden.costoInterno);
        if (orden.monedaId != 101) {
            costoPesos = helpers.methods.roundToTwo(parseFloat(orden.costoInterno) * monedaCotizacion);
        }
        totalCostoPesos += costoPesos;

        /* Calculo RB sin reembolsos */
        if (!(/true/i).test(orden.reembolsos)) {
            totalCotizacionSinReembolsos += parseFloat(orden.cotizacion) - parseFloat(orden.importeDescuento);
            totalFinanciacionSinReembolsos += parseFloat(importeFinanciacion);
            totalFeeSinReembolsos += parseFloat(importeFeeAgencia);

            totalNetoSinReembolsos += helpers.methods.roundToTwo(parseFloat(cotizacionOrden) 
                + parseFloat(importeFinanciacion)
                + parseFloat(importeFeeAgencia));

            totalCostoPesosSinReembolsos += costoPesos;
        }
    }); 

    /* Renglon de totales en la tabla de ordenes */
    state.ordenesTrabajoTotales = [];

    /* Total de cotizaciones en USD */
    if (state.monedaId) {
        if (state.monedaId == 102) {
            state.ordenesTrabajoTotales.push({
                monedaSimbolo: 'usd',
                cotizacion: subtotal,
            });
        }
    }

    /* Total de cotizaciones en $ */
    /* Cotización total sin descuentos */
    let subtotalPesos = subtotal;
    if (state.monedaId) {
        if (state.monedaId != 101) {
            subtotalPesos = helpers.methods.roundToTwo(parseFloat(subtotal) * parseFloat(monedaCotizacion));
        }
    }
    state.ordenesTrabajoTotales.push({
        monedaSimbolo: '$',
        costo: totalCostoPesos,
        cotizacion: subtotalPesos
    });
    
    let totalCotizacionFee = totalCotizacion + totalFee;
    let totalCotizacionFeeSinReembolsos = totalCotizacionSinReembolsos + totalFeeSinReembolsos;

    if (state.monedaId != 101) {
        totalCotizacionFee = (totalCotizacion + totalFee) * parseFloat(monedaCotizacion);
        totalCotizacionFeeSinReembolsos = (totalCotizacionSinReembolsos + totalFeeSinReembolsos) * parseFloat(monedaCotizacion);
    }

    state.pjeDescuento = 0;

    /* Aplicamos el pje de descuento sobre cotizacion y fee */
    if (totalCotizacionFee != 0 & state.importeDescuento != 0) {
        /* Calculamos el pje de descuento (incluyendo fee y financiacion) */
        state.pjeDescuento = parseFloat(state.importeDescuento) / parseFloat(totalNeto);

        totalCotizacionFee -= helpers.methods.roundToTwo(parseFloat(totalCotizacionFee) * parseFloat(state.pjeDescuento));
    }
    if (totalCotizacionFeeSinReembolsos != 0 & state.importeDescuento != 0) {
        /* Calculamos el pje de descuento (incluyendo fee y financiacion) */
        let pjeDescuentoSinReembolsos = parseFloat(state.importeDescuento) / parseFloat(totalNetoSinReembolsos);

        totalCotizacionFeeSinReembolsos -= helpers.methods.roundToTwo(parseFloat(totalCotizacionFeeSinReembolsos) * parseFloat(pjeDescuentoSinReembolsos));
    }

    /* Actualizamos el monto base para el cálculo de la comisión */
    state.montoBaseComision = helpers.methods.roundToTwo(montoBaseComision);

    let totalComision = 0;
    if (Array.isArray(state.vendedoresComisiones) && state.vendedoresComisiones.length > 0) {
        state.vendedoresComisiones.forEach(vendedorComision => {
            let pjeComision = parseFloat(vendedorComision.pjeComision) || 0;
            switch (vendedorComision.tipoComision) {
                case 1: /* Porcentaje */
                    totalComision += helpers.methods.roundToTwo(parseFloat(state.montoBaseComision) * parseFloat(pjeComision) / 100);
                    break;

                case 2: /* Importe */
                    totalComision += parseFloat(vendedorComision.importe) || 0;
                    break;
                    
                case 3: /* Porcentaje + Importe */
                    totalComision += helpers.methods.roundToTwo(parseFloat(state.montoBaseComision) * parseFloat(pjeComision) / 100);
                    totalComision += parseFloat(vendedorComision.importe) || 0;
                    break;
            }
        });
    }

    /* 2026-03-03: Sumamos la comisión al costo para el cálculo de rentabilidad */
    totalCostoPesos += helpers.methods.roundToTwo(totalComision);
    totalCostoPesosSinReembolsos += helpers.methods.roundToTwo(totalComision);

    /* Rentabilidad a partir de la cotización */
    let pjeRentabilidad = 0;
    let pjeRentabilidadSinReembolsos = 0;

    if (totalCotizacionFee != 0) {
        pjeRentabilidad = (parseFloat(totalCotizacionFee) 
            - parseFloat(totalCostoPesos)) / parseFloat(totalCotizacionFee) * 100 ;
    }
    if (totalCotizacionFeeSinReembolsos != 0) {
        pjeRentabilidadSinReembolsos = (parseFloat(totalCotizacionFeeSinReembolsos) 
            - parseFloat(totalCostoPesosSinReembolsos)) / parseFloat(totalCotizacionFeeSinReembolsos) * 100 ;
    }

    /* Montos totales */
    state.montoCosto = totalCostoPesos;
    state.montoCotizacionBruta = totalCotizacionBruta;
    state.montoDescuentoOrdenes = totalDescuentoOrdenes;
    state.montoCotizacion = totalCotizacion;
    state.montoSubtotalRebate = subtotalRebate;
    state.montoFinanciacion = totalFinanciacion;
    state.montoFee = totalFee;
    state.montoFeePremios = 0;
    state.montoSubtotal = totalNeto;

    /* Aplicamos el descuento sobre monto neto (fee y financiacion incluidos) */
    totalNeto = helpers.methods.roundToTwo(parseFloat(totalNeto) - parseFloat(state.importeDescuento));

    let calculoImpuestos = true;
    /* No calculo impuestos para clientes con condicion: SUJETO DEL EXTERIOR */
    if (state.condicionFiscalId == 3) {
        calculoImpuestos = false;
    }
    
    let totalImpuestos = 0;
    if (calculoImpuestos) {
        totalImpuestos = helpers.methods.roundToTwo(parseFloat(totalNeto) * parseFloat(state.pjeIva) / 100);
    }
    
    /* Total en la moneda del PI */
    state.montoNeto = totalNeto;
    state.montoTotal = parseFloat(totalNeto) + parseFloat(totalImpuestos);
    state.montoTotalPesos = parseFloat(totalNeto) + parseFloat(totalImpuestos);

    state.montoImpuestos = totalImpuestos;
    if (state.monedaId) {
        if (state.monedaId != 101) {
            state.montoTotalPesos = helpers.methods.roundToTwo(parseFloat(state.montoTotal) * parseFloat(monedaCotizacion));
            state.montoNeto = helpers.methods.roundToTwo(parseFloat(totalNeto) * parseFloat(monedaCotizacion));
            state.montoImpuestos = helpers.methods.roundToTwo(parseFloat(totalImpuestos) * parseFloat(monedaCotizacion));
        }
    }

    state.pjeRentabilidad = pjeRentabilidad;
    state.pjeRentabilidadSinReembolsos = pjeRentabilidadSinReembolsos;
}

function calcularTotalesOrden (state) {
    state.alternativasDatos = [];

    /* Calculamos el pje de descuento de rebate (sobre cotización sin fee ni financiación) */
    let cotizacion = state.ordenesTrabajo.reduce((total, orden) => {
        return total + parseFloat(orden.cotizacion);
    }, 0);

    let pjeDescuentoRebate = 0;
    if (cotizacion != 0 && state.importeDescuentoRebate != 0) {
        pjeDescuentoRebate = parseFloat(state.importeDescuentoRebate) / parseFloat(cotizacion);
    }

    if (state.ordenTrabajoAlternativas) {
        state.ordenTrabajoAlternativas.alternativas.forEach(alternativa => {
            /* Calculo la cotización con el descuento de rebate incluido */
            let cotizacionAlternativa = parseFloat(alternativa.cotizacion);
            if (pjeDescuentoRebate != 0) {
                cotizacionAlternativa -= helpers.methods.roundToTwo(parseFloat(alternativa.cotizacion) * parseFloat(pjeDescuentoRebate));
            }

            /* Calculo Fee + Financiacion */ 
            /* Aplico el pje de financiación sobre la cotización con descuento */
            let importeFinanciacionOrden = parseFloat(cotizacionAlternativa) * parseFloat(state.pjeFinanciacion) / 100;
            
            let importeFeeAgenciaOrden = 0;

            let aplicarFeeOrden = true;

            /* Servicio propio (según condición del cliente aplica o no fee) */
            if ((/true/i).test(state.servicioPropioNoAplicaFee)) {
                if (state.ordenTrabajoAlternativas.categoriaServicioId == 1) {
                    aplicarFeeOrden = false;
                }
            }

            /* Según condición del rubro para el cliente aplica o no fee */
            if ((/true/i).test(state.ordenTrabajoAlternativas.noAplicaFee)) {
                aplicarFeeOrden = false;
            }

            if (aplicarFeeOrden) {
                let feeAgenciaOrden = parseFloat(state.feeAgencia);
                if ((/true/i).test(state.discriminarFeePremios)) {
                    if ((/true/i).test(state.ordenTrabajoAlternativas.premios)) {
                        feeAgenciaOrden = parseFloat(state.feeAgenciaPremios);
                    }
                }
                
                /* Calculo sobre la cotización con el descuento de rebate incluido */
                if ((/true/i).test(state.feeSobreFinanciacion)) {
                    /*  Calculamos el pje de fee sobre la cotizacion + el pje de financiacion */
                    importeFeeAgenciaOrden = (parseFloat(cotizacionAlternativa) + parseFloat(importeFinanciacionOrden)) 
                        * parseFloat(feeAgenciaOrden) / 100;
                } else {
                    importeFeeAgenciaOrden = parseFloat(cotizacionAlternativa) * parseFloat(feeAgenciaOrden) / 100;
                }
            }

            /* Cotización final (c/fee y financiación) */
            /* Cotización con el descuento de rebate incluiro */
            let cotizacionFinal = helpers.methods.roundToTwo(parseFloat(cotizacionAlternativa) 
                + parseFloat(importeFinanciacionOrden)
                + parseFloat(importeFeeAgenciaOrden));

            state.alternativasDatos.push({
                id: alternativa.id,
                ordenTrabajoAlternativa: alternativa,
    
                rubroTrabajo: state.ordenTrabajoAlternativas.rubroTrabajo? state.ordenTrabajoAlternativas.rubroTrabajo.nombre.trim() : null,
                categoriaServicioId: state.ordenTrabajoAlternativas.categoriaServicioId,
                categoriaServicio: state.ordenTrabajoAlternativas.categoriaServicio? state.ordenTrabajoAlternativas.categoriaServicio.nombre.trim() : null,
                titulo: alternativa.titulo.trim(),
                cantidad: alternativa.cantidad,
                moneda: alternativa.moneda? alternativa.moneda.nombre.trim() : null,
                costoEstimado: alternativa.costoEstimado,
                pjeRentabilidad: alternativa.pjeRentabilidad,
                pjeRentabilidadInvalido: alternativa.pjeRentabilidadInvalido,
                costoInterno: alternativa.costoInterno,
                cotizacionInterna: alternativa.cotizacionInterna,
                cotizacion: alternativa.cotizacion,
                
                cotizacionFinal,
    
                seleccionada: alternativa.seleccionada,
    
                /* Detalles de la orden de trabajo */
                _showDetails : Boolean(true),
                /* Determina si se certifico el renglon (total o parcialmente) */
                certificado: false,
                /* Monto certificado */
                montoCertificado: 0.00,
                /* Determina si tiene imagenes */
                tieneImagenes: false,
                // tieneImagenes: Boolean(orden.tieneImagenes),
    
                cotizacionInternaDisabled: state.pjeRecargoServicioPropio == 0,
                cotizacionDisabled: state.pjeRecargoServicioPropio != 0,
    
                _rowVariant: ''
                // _rowVariant: alternativa.seleccionada? 'primary' : ''
            });
        }); 
    }
}

function isValidoDescuentoOrden (state, ordenTrabajo) {
    /* Calculo Fee + Financiacion */ 
    /* Cotizacion = Cotizacion - ImporteDescuento */
    let cotizacionOrden = parseFloat(ordenTrabajo.cotizacion) - parseFloat(ordenTrabajo.importeDescuento);

    let importeFinanciacion = parseFloat(cotizacionOrden) * parseFloat(state.pjeFinanciacion) / 100;
    let importeFeeAgencia = 0;

    let aplicarFee = true;

    /* Servicio propio (según condición del cliente aplica o no fee) */
    if ((/true/i).test(state.servicioPropioNoAplicaFee)) {
        if (ordenTrabajo.categoriaServicioId == 1) {
            aplicarFee = false;
        }
    }

    /* Según condición del rubro para el cliente aplica o no fee */
    if ((/true/i).test(ordenTrabajo.noAplicaFee)) {
        aplicarFee = false;
    }

    if (aplicarFee) {
        let feeAgencia = parseFloat(state.feeAgencia);
        if ((/true/i).test(state.discriminarFeePremios)) {
            if ((/true/i).test(ordenTrabajo.premios)) {
                feeAgencia = parseFloat(state.feeAgenciaPremios);
            }
        }
        
        if ((/true/i).test(state.feeSobreFinanciacion)) {
            /*  Calculamos el pje de fee sobre la cotizacion + el pje de financiacion */
            importeFeeAgencia = (parseFloat(cotizacionOrden) + parseFloat(importeFinanciacion)) 
                * parseFloat(feeAgencia) / 100;
        } else {
            importeFeeAgencia = parseFloat(cotizacionOrden) * parseFloat(feeAgencia) / 100;
        }
    }

    /* Cotización final (c/fee y financiación) */
    let cotizacion = helpers.methods.roundToTwo(parseFloat(cotizacionOrden) 
        + parseFloat(importeFinanciacion)
        + parseFloat(importeFeeAgencia));
    
    if (state.pjeDescuento != 0) {
        cotizacion = helpers.methods.roundToTwo(cotizacion * (1 - state.pjeDescuento));
    }
        
    if (ordenTrabajo.montoCertificado > cotizacion) {
        return false;
    }

    return true;
}

/* Compara cotización c/descuento únicamente */
function isMontoCertificadoValido (state, ordenTrabajo) {
    /* Cotizacion = Cotizacion - ImporteDescuento */
    let cotizacionOrden = parseFloat(ordenTrabajo.cotizacion) - parseFloat(ordenTrabajo.importeDescuento);

    let pjeDescuento = Number(state.pjeDescuento) || 0;
    let montoCertificado = Number(ordenTrabajo.montoCertificado) || 0;

    if (pjeDescuento != 0) {
        cotizacionOrden = helpers.methods.roundToTwo(cotizacionOrden * (1 - pjeDescuento));
    }

    const diferencia = (a, b) => {
        const numA = Number(a) || 0;
        const numB = Number(b) || 0;
        return Math.abs(Math.round(numA * 100) / 100 - Math.round(numB * 100) / 100);
    };    

    if (montoCertificado > cotizacionOrden) {
        return diferencia(montoCertificado, cotizacionOrden) <= 1;
    }

    return true;
}

const getters = {
    getField,

    vistaOrdenesDatos (state) {
        return state.vistaOrdenesDatos;
    },
    verTotales (state) {
        return state.verTotales;
    },
    presupuestoSearch (state) {
        return state.presupuestoSearch;
    },
    ordenesListSearch (state) {
        return state.ordenesListSearch;
    },
    presupuestoProduccionRpt (state) {
        return state.presupuestoProduccionRpt;
    },
    ordenesProduccion (state) {
        return state.ordenesProduccion;
    },
};

const actions = {
    inicializar ( { commit, rootState, rootGetters }, params ) {
        return new Promise((resolve, reject) => {
            let presupuestoId = 0;
            let presupuestoInicialId = 0;

            if (params) {
                if (params.presupuestoId) {
                    if (params.presupuestoId != 0) {
                        presupuestoId = params.presupuestoId;
                    }
                }
                if (params.presupuestoInicialId) {
                    if (params.presupuestoInicialId != 0) {
                        presupuestoInicialId = params.presupuestoInicialId;
                    }
                }
            }

            let accesoComisiones = Boolean(rootGetters['user/tieneAccesoModulo']('PresupuestosInternosComisiones'));

            let init = {
                presupuestoId,
                accesoComisiones
            }

            commit('INICIALIZAR_PRESUPUESTO', init);

            if (presupuestoId != 0) {
                apiAxios.get('provincias/list?paisId=1') 
                    .then(res => {
                        commit('SET_PROVINCIAS', res.data);

                        /* Recuperamos el listado de usuarios */
                        return apiAxios.get('usuarios/asign') 
                    })
                    .then(res => {
                        commit('SET_USUARIOS', res.data);

                        /* Inicializamos la información del presupuesto */
                        return apiAxios.get('presupuestosinternos/inicializar')
                    })
                    .then(res => {
                        const pjeComisionInterna = res.data.pjeComisionInterna || 0;
                        
                        commit('SET_PJE_COMISION_INTERNA', pjeComisionInterna);

                        /* Recuperamos la información del presupuesto */
                        return apiAxios.get(`presupuestosinternos/${presupuestoId}/abm` ) 
                    })
                    .then(res => {
                        let paramsPresupuesto = {
                            presupuesto: res.data.presupuesto,
                            ordenesTrabajos: res.data.ordenesTrabajos,
                            facturacion: res.data.facturacion,
                            provincias: res.data.provincias,
                            usuarios: res.data.usuarios,
                            usuariosPropuesta: res.data.usuariosPropuesta,
                            vendedoresComisiones: res.data.vendedoresComisiones
                        }
                        commit('SET_PRESUPUESTO', paramsPresupuesto);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));

            } else if (presupuestoInicialId != 0) {
                apiAxios.get('provincias/list?paisId=1') 
                    .then(res => {
                        commit('SET_PROVINCIAS', res.data);

                        /* Recuperamos el listado de usuarios */
                        return apiAxios.get('usuarios/asign') 
                    })
                    .then(res => {
                        commit('SET_USUARIOS', res.data);

                        /* Inicializamos la información del presupuesto */
                        return apiAxios.get('presupuestosinternos/inicializar')
                    })
                    .then(res => {
                        const pjeComisionInterna = res.data.pjeComisionInterna || 0;
                        
                        commit('SET_PJE_COMISION_INTERNA', pjeComisionInterna);

                        /* Recuperamos la información del presupuesto */
                        return apiAxios.get(`presupuestosinternos/${presupuestoInicialId}/adicional`)
                    })
                    .then(res => {
                        let paramsPresupuesto = {
                            presupuesto: res.data.presupuesto,
                            ordenesTrabajos: res.data.ordenesTrabajos,
                            provincias: res.data.provincias
                        }
                        commit('SET_PRESUPUESTO', paramsPresupuesto);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                /* Recuperamos los parametros para un nuevo presupuesto */
                apiAxios.get('provincias/list?paisId=1') 
                    .then(res => {
                        commit('SET_PROVINCIAS', res.data);

                        /* Recuperamos el listado de usuarios */
                        return apiAxios.get('usuarios/asign') 
                    })
                    .then(res => {
                        commit('SET_USUARIOS', res.data);

                        /* Inicializamos la información del presupuesto */
                        return apiAxios.get('presupuestosinternos/inicializar')
                    })
                    .then(res => {
                        /* Recuperamos el nombre del usuario logueado */
                        res.data.usuario = rootState.user.nombreCompleto.trim();

                        commit('SET_PARAMETROS_PRESUPUESTO', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })            
    },
    save ( { state, rootState } ) {
        return new Promise((resolve, reject) => {
            let update = true;
            let errorMessage = '';
            let errorCostoInterno = false;
            let errorPjeRentabilidad = false;
            let errorCotizacion = false;
            let errorMontoCertificado = false;
            let errorCategoriaServicio = false;
            let errorMargenMinimo = false;
            let errorDescuentoRenglonCertificado = false;

            /* Calculamos el pje de descuento */
            let cotizacion = state.ordenesTrabajo.reduce((total, orden) => {
                return total + parseFloat(orden.cotizacion);
            }, 0);

            state.ordenesTrabajo.forEach(orden => {
                let error = false;

                if (isNaN(orden.costoInterno)) {
                    errorCostoInterno = true;
                    error = true;
                }
                if (isNaN(orden.pjeRentabilidad)) {
                    errorPjeRentabilidad = true;
                    error = true;
                }
                if (isNaN(orden.cotizacion)) {
                    errorCotizacion = true;
                    error = true;
                } else {
                    if (!isMontoCertificadoValido(state, orden)) {
                        errorMontoCertificado = true;
                        error = true;
                    }
                }

                /* Si el presupuesto discrimina categorias y la orden no tiene una definida */
                if ((/true/i).test(state.discriminarCategoriaServicio)) {
                    if (orden.categoriaServicioId == 0) {
                        let errorCategoria = true;
                        if (orden.categoriaServicioId) {
                            if (orden.categoriaServicioId != 0) {
                                errorCategoria = false;
                            }
                        }

                        if (errorCategoria) {
                            errorCategoriaServicio = true;
                            error = true;
                        }
                    }
                }
                
                /* Si tiene una autorización, no validamos los pjes de rentabilidad */
                if (!(/true/i).test(state.autorizado)) {
                    if (orden.cotizacion != 0 ) {
                        /* Validamos de acuerdo al pje de rentabilidad del rubro y los minimos del cliente */
                        let pjeRentabilidadMinima = parseFloat(orden.pjeRentabilidadMinima);

                        /* Si la rentabilidad minima del cliente es mayor, tomamos la del cliente (segun la categoría de servicio) */
                        if ((/true/i).test(state.discriminarCategoriaServicio)) {
                            if (orden.categoriaServicioId == 1) {
                                if (parseFloat(state.pjeMargenMinimoCotizacionPropio) > pjeRentabilidadMinima) {
                                    pjeRentabilidadMinima = parseFloat(state.pjeMargenMinimoCotizacionPropio);
                                }
                            } else {
                                if (parseFloat(state.pjeMargenMinimoCotizacionTerceros) > pjeRentabilidadMinima) {
                                    pjeRentabilidadMinima = parseFloat(state.pjeMargenMinimoCotizacionTerceros);
                                }
                            }
                        } else {
                            /* Si la rentabilidad minima del cliente es mayor, tomamos la del cliente */
                            if (parseFloat(state.pjeMargenMinimoCotizacion) > pjeRentabilidadMinima) {
                                pjeRentabilidadMinima = parseFloat(state.pjeMargenMinimoCotizacion);
                            }
                        }

                        if (orden.pjeRentabilidad < pjeRentabilidadMinima) {
                            errorMargenMinimo = true;
                            error = true;
                        }
                    }
                }

                /* Validamos que el monto con descuento no sea menor al monto certificado */
                if (state.pjeDescuento != 0 & orden.montoCertificado != 0) {
                    if (!isValidoDescuentoOrden(state, orden)) {
                        errorDescuentoRenglonCertificado = true;
                        error = true;
                    }
                }

                let ordenTrabajoDatos = state.ordenesTrabajoDatos.find(ordenTrabajoDatos => ordenTrabajoDatos.ordenTrabajo.ordenTrabajoId == orden.ordenTrabajoId);
                if (ordenTrabajoDatos) {
                    ordenTrabajoDatos._rowVariant = error? 'danger' : '';
                }
            });

            /* Mostramos los errores a nivel de cada renglón */
            if (errorCostoInterno | errorCotizacion | errorPjeRentabilidad | errorMontoCertificado
                    | errorCategoriaServicio | errorMargenMinimo | errorDescuentoRenglonCertificado) {
                update = false;

                if (errorCostoInterno) {
                    errorMessage = 'Una o más órdenes no tienen definido un costo interno válido.';
                }
                if (errorPjeRentabilidad) {
                    if (errorMessage == '') {
                        errorMessage = 'Una o más órdenes no tienen definido un pje de rentabilidad válido.';
                    } else {
                        errorMessage += '\nUna o más órdenes no tienen definido un pje de rentabilidad válido.';
                    }
                }
                if (errorCotizacion) {
                    if (errorMessage == '') {
                        errorMessage = 'Una o más órdenes no tienen definida una cotización válida.';
                    } else {
                        errorMessage += '\nUna o más órdenes no tienen definida una cotización válida.';
                    }
                }
                if (errorMontoCertificado) {
                    if (errorMessage == '') {
                        errorMessage = 'Una o más órdenes tienen un importe certificado mayor a la cotización actual.';
                    } else {
                        errorMessage += '\nUna o más órdenes tienen un importe certificado mayor a la cotización actual.';
                    }
                }
                if (errorCategoriaServicio) {
                    if (errorMessage == '') {
                        errorMessage = 'Una o más órdenes no tienen definida la categoria de servicio';
                    } else {
                        errorMessage += '\nUna o más órdenes no tienen definida la categoria de servicio';
                    }
                }
                if (errorMargenMinimo) {
                    if (errorMessage == '') {
                        errorMessage = 'Una o más órdenes tienen un pje de rentabilidad menor al mínimo permitido';
                    } else {
                        errorMessage += '\nUna o más órdenes tienen un pje de rentabilidad menor al mínimo permitido';
                    }
                }
                if (errorDescuentoRenglonCertificado) {
                    if (errorMessage == '') {
                        errorMessage = 'Una o más órdenes tienen un importe neto con descuento menor al importe certificado';
                    } else {
                        errorMessage += '\nUna o más órdenes tienen un importe neto con descuento menor al importe certificado';
                    }
                }
            }

            /* Validamos la rentabilidad bruta general */
            // if (update) {
            //     if (state.pjeRentabilidad < 40) {
            //         if (!(/true/i).test(state.autorizado)) {
            //             update = false;
            //             errorMessage = 'La rentabilidad bruta general es menor al 40%.';
            //         }
            //     } else if (state.pjeRentabilidad < 50) {
            //         if (!(/true/i).test(state.autorizado)) {
            //             update = false;
            //             errorMessage = 'La rentabilidad bruta general es menor al 50%.';
            //         }
            //     }
            // }

            if (update) {
                let ordenes = [];
                state.ordenesTrabajo.forEach(orden => {
                    ordenes.push({
                        ordenTrabajoId: orden.ordenTrabajoId,
                        rubroTrabajoId: parseInt(orden.rubroTrabajoId),
                        rubroTrabajo: orden.rubroTrabajo,
                        categoriaServicioId: parseInt(orden.categoriaServicioId),
                        titulo: orden.titulo.toUpperCase().trim(),
                        pjeRentabilidadMaxima: 0, //parseFloat(orden.pjeRentabilidadMaxima),
                        pjeRentabilidadMinima: parseFloat(orden.pjeRentabilidadMinima),
                        premios: (/true/i).test(orden.premios),
                        reembolsos: (/true/i).test(orden.reembolsos),
                        noAplicaFee: (/true/i).test(orden.noAplicaFee),
                        excluidoComisiones: (/true/i).test(orden.excluidoComisiones),
                        /* Parámetros para el cálculo del costo interno */
                        parametrosGlobales: (/true/i).test(orden.parametrosGlobales),
                        pjeGastosFijos: parseFloat(orden.pjeGastosFijos),
                        pjeInversionFutura: parseFloat(orden.pjeInversionFutura),
                        pjeImpuestosInternos: parseFloat(orden.pjeImpuestosInternos),

                        descripcion: orden.descripcion.trim(),
                        cantidad: parseFloat(orden.cantidad),
                        monedaId: parseInt(orden.monedaId),
                        costoEstimado: parseFloat(orden.costoEstimado),
                        costoEstimadoTotal: parseFloat(orden.costoEstimadoTotal),
                        costoUnitario: (/true/i).test(orden.costoUnitario),
                        costoInterno: parseFloat(orden.costoInterno),
                        proveedorId: parseInt(orden.proveedorId),
                        proveedor: orden.proveedor,
                        costoProveedor: parseFloat(orden.costoProveedor),
                        pjeRentabilidad: parseFloat(orden.pjeRentabilidad),
                        cotizacionInterna: parseFloat(orden.cotizacionInterna),
                        cotizacion: parseFloat(orden.cotizacion),
                        importeDescuento: parseFloat(orden.importeDescuento),
                        
                        /* Alternativas */
                        alternativas: orden.alternativas
                    })
                });

                let fechaOrdenCompra = EMPTY_DATE;
                if ((/true/i).test(state.fechaOrdenCompraHabilitada)) {
                    fechaOrdenCompra = moment(state.fechaOrdenCompra).format('YYYY-MM-DD');
                }

                let presupuesto= {
                    presupuestoInternoId: state.presupuestoInternoInicialId,
                    fechaConfirmacion: moment(state.fechaConfirmacion).format('YYYY-MM-DD'),
                    fechaEntrega: moment(state.fechaEntrega).format('YYYY-MM-DD'),
                    tipoPresupuestoId: parseInt(state.tipoPresupuestoId),
                    clienteId: parseInt(state.clienteId),
                    cliente: state.cliente,
                    condicionFiscalId: parseInt(state.condicionFiscalId),
                    accion: state.accion.toUpperCase().trim(), 
                    clienteContactoId: parseInt(state.clienteContactoId),
                    clienteContacto: state.clienteContacto,
                    numeroOrdenCompra: state.numeroOrdenCompra.toUpperCase().trim(),
                    fechaOrdenCompra,
                    descripcionOrdenCompra: state.descripcionOrdenCompra.toUpperCase().trim(),
                    prioridadId: parseInt(state.prioridadId),
                    prioridad: state.prioridad,
                    monedaId: parseInt(state.monedaId),
                    moneda: state.moneda,
                    monedaCotizacion: parseFloat(state.monedaCotizacion),
                    pjeGastosFijos: parseFloat(state.pjeGastosFijos),
                    pjeInversionFutura: parseFloat(state.pjeInversionFutura),
                    pjeImpuestosInternos: parseFloat(state.pjeImpuestosInternos),
                    pjeIva: parseFloat(state.pjeIva),
                    feeAgencia: parseFloat(state.feeAgencia),
                    aplicarEscalaFee: (/true/i).test(state.aplicarEscalaFee),
                    escalasFee: state.escalasFee,
                    feeAgenciaPremios: parseFloat(state.feeAgenciaPremios),
                    discriminarFee: state.discriminarFee,
                    ocultarLeyendaFee: state.ocultarLeyendaFee,
                    discriminarFeePremios: state.discriminarFeePremios,
                    // feeComisionable: state.feeComisionable,
                    pjeFinanciacion: parseFloat(state.pjeFinanciacion),
                    aplicarEscalaFinanciacion: (/true/i).test(state.aplicarEscalaFinanciacion),
                    pjeFinanciacionCliente: parseFloat(state.pjeFinanciacionCliente),
                    discriminarPjeFinanciacion: state.discriminarPjeFinanciacion,
                    feeSobreFinanciacion: state.feeSobreFinanciacion,
                    escalasFinanciacion: state.escalasFinanciacion,
                    discriminarCategoriaServicio: state.discriminarCategoriaServicio,
                    servicioPropioNoAplicaFee: state.servicioPropioNoAplicaFee,
                    prontoPagoFeeDiferenciado: state.prontoPagoFeeDiferenciado,
                    pjeRecargoServicioPropio: parseFloat(state.pjeRecargoServicioPropio),
                    pjeMargenMinimoCotizacion: parseFloat(state.pjeMargenMinimoCotizacion),
                    pjeMargenMinimoCotizacionPropio: parseFloat(state.pjeMargenMinimoCotizacionPropio),
                    pjeMargenMinimoCotizacionTerceros: parseFloat(state.pjeMargenMinimoCotizacionTerceros),
                    importeDescuentoRebate: parseFloat(state.importeDescuentoRebate),
                    importeDescuento: parseFloat(state.importeDescuento),
                    causaSocial: (/true/i).test(state.causaSocial),
                    causaAmbiental: (/true/i).test(state.causaAmbiental),
                    seleccionProvincias: (/true/i).test(state.seleccionProvincias),
                    propuestaAgencia: (/true/i).test(state.propuestaAgencia),
                    reembolsos: state.reembolsos,
                    usuarioCoordinadorId: state.usuarioCoordinadorId,
                };

                let provincias = state.provincias
                    .filter(t => t.seleccionada)
                    .map(t => ({
                        provinciaId: t.provinciaId
                    }));

                let usuarios = state.usuarios
                    .filter(t => t.asignado)
                    .map(t => ({
                        usuarioId: t.usuarioId,
                        usuarioRolId: t.usuarioRolId,
                        asignado: true,
                        inactivo: (/true/i).test(t.inactivo)
                    }));
                
                let usuariosPropuesta = [];

                if ((/true/i).test(state.propuestaAgencia)) {
                    usuariosPropuesta = state.usuariosPropuesta
                        .filter(t => t.asignado)
                        .map(t => ({
                            usuarioId: t.usuarioId,
                            usuarioRolId: t.usuarioRolId,
                            asignado: true,
                            inactivo: (/true/i).test(t.inactivo)
                        }));
                }

                let presupuestoABM = {
                    presupuesto,
                    ordenesTrabajos: ordenes,
                    facturacion: state.facturacion,
                    provincias,
                    usuarios,
                    usuariosPropuesta
                }
                
                if ((/true/i).test(state.accesoComisiones)) {
                    let vendedoresComisiones = [];

                    if (Array.isArray(state.vendedoresComisiones) && state.vendedoresComisiones.length > 0) {
                        vendedoresComisiones = state.vendedoresComisiones.map(vendedorComision => ({
                            vendedorId: vendedorComision.vendedorId,
                            personalId: vendedorComision.personalId,
                            tipoComision: vendedorComision.tipoComision,
                            tipoPjeComision: vendedorComision.tipoPjeComision,
                            pjeComisionVendedor: vendedorComision.pjeComisionVendedor,
                            pjeFeeComisionVendedor: vendedorComision.pjeFeeComisionVendedor,
                            importeVendedor: vendedorComision.importeVendedor,
                            pjeComisionPresupuesto: vendedorComision.pjeComisionPresupuesto,
                            pjeFeeComisionPresupuesto: vendedorComision.pjeFeeComisionPresupuesto,
                            importePresupuesto: vendedorComision.importePresupuesto,
                            pjeComision: vendedorComision.pjeComision,
                            importe: vendedorComision.importe
                        }));
                    }

                    presupuestoABM.vendedoresComisiones = vendedoresComisiones;
                }
        

                let url = 'presupuestosinternos';
                if (state.id != 0) {
                    url += '/' + state.id;
                    presupuesto.rowVersion = state.rowVersion;
                }

                apiAxios.post(url, presupuestoABM)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(errorMessage);
            }
        })
    },
    addOrden: ({commit}, orden) => {
        commit('ADD_ORDEN', orden);
    },
    selectOrden: ({commit}, orden) => {
        commit('SELECT_ORDEN', orden);
    },
    updateOrden: ({commit}, orden) => {
        commit('UPDATE_ORDEN', orden);
    },
    updatePjeRentabilidadOrden: ( { commit }, params) => {
        return new Promise((resolve, reject) => {
            commit('UPDATE_ORDEN_PJE_RENTABILIDAD', params);
            resolve();
        })
    },
    ajustarMontoCertificado: ( { commit }, ordenTrabajo) => {
        return new Promise((resolve, reject) => {
            commit('AJUSTAR_MONTO_CERTIFICADO', ordenTrabajo);
            resolve();
        }, error => {
            reject(error);
        })
    },
    updateCotizacionOrden: ( { commit }, params) => {
        return new Promise((resolve, reject) => {
            commit('UPDATE_ORDEN_COTIZACION', params);
            resolve();
        }, error => {
            reject(error);
        })
    },
    updateCotizacionInternaOrden: ( { commit }, params) => {
        return new Promise((resolve, reject) => {
            commit('UPDATE_ORDEN_COTIZACION_INTERNA', params);
            resolve();
        }, error => {
            reject(error);
        })
    },
    updateDescuentoOrden: ( { commit }, params) => {
        return new Promise((resolve, reject) => {
            commit('UPDATE_DESCUENTO_ORDEN', params);
            resolve();
        }, error => {
            reject(error);
        })
    },
    deleteOrden: ( { commit }, ordenTrabajoId) => {
        return new Promise((resolve, reject) => {
            commit('DELETE_ORDEN', ordenTrabajoId);
            resolve();
        })
    },
    setOrdenTieneImagen: ({commit}, params) => {
        return new Promise((resolve, reject) => {
            commit('SET_TIENE_IMAGEN', params);
            resolve();
        })
    },
    consultarAlternativas: ({commit}, ordenTrabajo) => {
        commit('CONSULTAR_ALTERNATIVAS', ordenTrabajo);
    },
    clearConsultaAlternativas: ({commit}) => {
        commit('CLEAR_CONSULTA_ALTERNATIVAS');
    },
    selectOrdenAlternativa: ({commit}, ordenTrabajoAlternativa) => {
        commit('SELECT_ORDEN_ALTERNATIVA', ordenTrabajoAlternativa);
    },
    addOrdenAlternativa: ({commit}, ordenTrabajoAlternativa) => {
        commit('ADD_ORDEN_ALTERNATIVA', ordenTrabajoAlternativa);
    },
    updateOrdenAlternativa: ({commit}, ordenTrabajoAlternativa) => {
        commit('UPDATE_ORDEN_ALTERNATIVA', ordenTrabajoAlternativa);
    },
    deleteOrdenAlternativa: ({ commit }, ordenTrabajoAlternativaId) => {
        return new Promise((resolve, reject) => {
            commit('DELETE_ORDEN_ALTERNATIVA', ordenTrabajoAlternativaId);
            resolve();
        })
    },
    seleccionarOrdenAlternativa: ({commit}, ordenTrabajoAlternativa) => {
        commit('SELECCIONAR_ORDEN_ALTERNATIVA', ordenTrabajoAlternativa);
    },
    updateCotizacionOrdenAlternativa: ( { commit }, params) => {
        return new Promise((resolve, reject) => {
            commit('UPDATE_ORDEN_ALTERNATIVA_COTIZACION', params);
            resolve();
        }, error => {
            reject(error);
        })
    },
    updateCotizacionInternaOrdenAlternativa: ( { commit }, params) => {
        return new Promise((resolve, reject) => {
            commit('UPDATE_ORDEN_ALTERNATIVA_COTIZACION_INTERNA', params);
            resolve();
        }, error => {
            reject(error);
        })
    },
    updatePjeRentabilidadOrdenAlternativa: ( { commit }, params) => {
        return new Promise((resolve, reject) => {
            commit('UPDATE_ORDEN_ALTERNATIVA_PJE_RENTABILIDAD', params);
            resolve();
        })
    },
    setTipoPresupuesto: ({commit}, tipoPresupuesto) => {
        commit('SET_TIPO_PRESUPUESTO', tipoPresupuesto);
    },
    setCliente: ({ state, commit }, cliente) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CLIENTE');

            if (cliente) {
                // if ((/true/i).test(state.accesoComisiones)) {
                    apiAxios.get(`clientes/${cliente.id}/presupuestacion` ) 
                        .then(res => {
                            commit('SET_CLIENTE', res.data);
    
                            /* Validamos si tiene vendedores asociados */
                            let query = '?clienteId=' + state.clienteId
                                + '&clienteContactoId=' + state.clienteContactoId;
                            return apiAxios.get('vendedores/presupuesto' + query )
                        })
                        .then(res => {
                            commit('SET_VENDEDOR_COMISION_CLIENTE', res.data);
                            resolve();
                        })
                        .catch(error => reject(helpers.methods.getErrorMessage(error)));
                // } else {
                //     apiAxios.get(`clientes/${cliente.id}/presupuestacion` ) 
                //         .then(res => {
                //             commit('SET_CLIENTE', res.data);
                //             resolve();
                //         })
                //         .catch(error => reject(helpers.methods.getErrorMessage(error)));                        
                // }
            } else {
                resolve();
            }

        }, error => {
            reject(error);
        })
    },
    setClienteContacto: ({ state, commit }, clienteContacto) => {
        return new Promise((resolve, reject) => {
            commit('SET_CLIENTE_CONTACTO', clienteContacto);

            if ((/true/i).test(state.accesoComisiones)) {
                /* Validamos si tiene vendedores asociados */
                let query = '?clienteId=' + state.clienteId
                    + '&clienteContactoId=' + state.clienteContactoId;
            
                apiAxios.get('vendedores/presupuesto' + query )                         
                    .then(res => {
                        commit('SET_VENDEDOR_COMISION_CLIENTE', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }

        }, error => {
            reject(error);
        })
    },
    setPrioridad: ({commit}, prioridad) => {
        commit('SET_PRIORIDAD', prioridad);
    },
    setMoneda: ({commit}, moneda) => {
        commit('SET_MONEDA', moneda);
    },
    setUsuarioCoordinador: ({commit}, usuarioCoordinador) => {
        commit('SET_USUARIO_COORDINADOR', usuarioCoordinador);
    },
    setVendedorComision: ({commit}, vendedorComision) => {
        commit('SET_VENDEDOR_COMISION', vendedorComision);
    },
    deleteVendedorComision: ({commit}, vendedorId) => {
        commit('DELETE_VENDEDOR_COMISION', vendedorId);
    },
    updatePjeComision: ( { commit } ) => {
        commit('UPDATE_PJE_COMISION');
    },
    calcularTotales: ({commit}) => {
        commit('CALCULAR_TOTALES');
    },
    addFechaFacturacion: ( { commit }, facturacion) => {
        commit('ADD_FECHA_FACTURACION', facturacion);
    },
    updateFechaFacturacion: ( { commit }, facturacion) => {
        commit('UPDATE_FECHA_FACTURACION', facturacion);
    },
    removeFechaFacturacion: ( { commit }, facturacionId) => {
        commit('REMOVE_FECHA_FACTURACION', facturacionId);
    },
    actualizarNumeroOrdenCompra: ( {}, params) => {
        return new Promise((resolve, reject) => {
            let presupuesto = {
                numeroOrdenCompra: params.numeroOrdenCompra.trim().toUpperCase(),
            }
            let url = 'presupuestosinternos/' + params.presupuestoInternoId + '/ordencompra';
            apiAxios.post(url, presupuesto)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    confirmarPresupuesto: ( {}, presupuestoId) => {
        return new Promise((resolve, reject) => {
            let url = 'presupuestosinternos/' + presupuestoId + '/confirmar';
            apiAxios.post(url, )
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    anularConfirmacionPresupuesto: ( {}, presupuestoId) => {
        return new Promise((resolve, reject) => {
            let url = 'presupuestosinternos/' + presupuestoId + '/delconf';
            apiAxios.post(url, )
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    searchPresupuesto ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_SEARCH');

            let query = '?numero=' + params.numero;

            if (params.clienteId) {
                if (params.clienteId != 0) {
                    query += '&clienteId=' + params.clienteId;
                }
            }
            if (params.adicionalNumero) {
                if (params.adicionalNumero != 0) {
                    query += '&adicionalNumero=' + params.adicionalNumero;
                }
            }
            if (params.loadOrdenes) {
                if ((/true/i).test(params.loadOrdenes)) {
                    query += '&loadOrdenes=true';
                }
            }
            
            apiAxios.get('presupuestosinternos/search' + query) 
                .then(res => {
                    let status = parseInt(res.status);

                    if (status == 200) {
                        params.presupuestoInterno = res.data;

                        commit('SET_PRESUPUESTO_SEARCH', params);
                        resolve();
    
                    } else if (status == 204) {
                        reject('No se encontró el presupuesto interno con el número de presupuesto ingresado.');
                    } else {
                        reject('Se produjo un error al recuperar la información del presupuesto interno.');
                    }
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    addSubtrabajoSearch ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('ADD_SUBTRABAJO_SEARCH', params);
            resolve();
        })            
    },
    getImagenesRemitos: ( { commit }, presupuestoInternoId ) => {
        return new Promise((resolve, reject) => {
            apiAxios.get('presupuestosinternos/' + presupuestoInternoId + '/remitos/imagenes' ) 
                .then(res => {
                    commit('SET_IMAGENES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    descargarImagenes: ( {}, presupuestoInternoId ) => {
        return new Promise((resolve, reject) => {
            apiAxios.get('presupuestosinternos/' + presupuestoInternoId + '/remitos/imagenes/descargar' ) 
                .then(res => {
                    if (res.data == '') {
                        reject('Los remitos del presupuesto no tienen archivos asociados.')
                        return null;
                    }
                    
                    return extAxios.get(res.data, {responseType: 'blob'});
                })
                .then(res => {
                    if (res) {
                        saveAs(res.data, 'download.zip');
                    }
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    addPresupuestoByBrief ( {}, briefId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`presupuestosinternos/briefs/${briefId}`)
                .then(res => {
                    // commit('SET_BRIEF_ID', res.data.id);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    actualizarCierreEstimado: ( {}, params) => {
        return new Promise((resolve, reject) => {
            const url = `presupuestosinternos/${params.presupuestoInternoId}/cierre-estimado`;

            const fecha = {
                fecha: params.fecha
            }

            apiAxios.post(url, fecha)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}